/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import { connect } from "react-redux";
import Input from "../../../component/inputpm";
import Grid from "@mui/material/Grid";
// import Select from '../../../component/select';
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import stateCode from "../../../helper/stateCode";
import InputPhone from "../../../component/inputPhone";
import { withTranslation, Trans } from "react-i18next";

import FormControlLabel from "@mui/material/FormControlLabel";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import Loader from "../../../component/loader";

import Button from "../../../component/button";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import InputLabel from "@mui/material/InputLabel";
import AddressList from "./addressList";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { TableContainer, TableFooter } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
import classes from "./customer.module.css";
import Delete from "@mui/icons-material/Delete";
import Divider from "@mui/material/Divider";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import actionTypes from "../../../store/actions";
import PaymentDetails from "./paymentDetails";
import AddressDetails from "./addressDetails";
import Chip from "@mui/material/Chip";
import { getStateName, getStatesList } from "../../../helper/getStateList.js";
// import TextEditor from "../../../component/richTextEditor/index.js";
import TiptapEditor from "../../../component/richTextEditor/TiptapEditor.js";
import { getDraftContentStats } from "../../../component/richTextEditor/getContentStats.js";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromRaw,
  Modifier,
} from "draft-js";
import UriEncode from "../../../component/uriEncode/uriEncode.js";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Tooltip, Paper, Icon } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import pdfIcon from "../../../asset/images/pdf.png";
import placeholderImage from "../../../asset/images/image_placeholder.png";
import {
  DeleteIcon,
  DeleteIconNew,
  DownloadIconNew,
  ViewIconNew,
} from "../../../component/icons/icons.js";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
// import { withStyles } from '@mui/styles';
import DynamicDropdowns from "./dynamicDropdowns";
import moment from "moment";
import FormHelperText from "@mui/material/FormHelperText";
import Base64ViewerDialog from "../../../component/fileViewer/index.js";
import { formatDate } from "../../../helper/dateFormatter";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import InputAdornment from "@mui/material/InputAdornment";
import SearchUsersDialog from "../../sales/checkout/customerDetails/searchUsersDialog.js";

class CustomerDetails extends Component {
  state = {
    loading: false,
    partialLoading: false,
    firstName: "",
    lastName: "",
    mobilePhone: "",
    officePhone: "",
    emailMechId: "",
    mobilePhoneMechId: "",
    officePhoneMechId: "",
    customersEmployeeList: [],
    billingCloseDay: "1",
    showForm: false,
    days: [],
    profileData: {},
    shipping: {},
    error: {},
    isManaged: false,
    facilityNamePrefix: "",
    showFacilityPrefixName: false,
    manageCustomerRequired: false,
    stateName: "",
    statesList: [],

    // notesState: EditorState.createEmpty(),
    // originalNotesState: EditorState.createEmpty(),
    customerNote:
      '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    originalCustomerNote:
      '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    localisedCustomerNote: [
      {
        locale: "en_US",
        text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
      },
    ],
    originalLocalisedCustomerNote: [
      {
        locale: "en_US",
        text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
      },
    ],
    oldNotes: false,
    showUploadDailog: false,
    assessmentData: {
      name: "",
      data: "",
      format: "",
      fileName: "",
    },
    attachments: [],
    stateNameLoading: true,
    attachmentToDelete: {},
    confirmDeleteAttachment: false,
    uploadAssesmentError: {
      show: false,
      msg: "",
    },
    tabValue: this.props.isTaskMode
      ? 3
      : this.props.providerType === "SALES_CHNL_PROVIDER"
        ? 0
        : 2,
    editNote: false,
    modules: {},
    isInvalidBan: false,
    success: {},
    userVerified: false,
    reviewers: {},
    dropdownStructure: [
      {
        key: "role",
        label: "Role",
        idKey: "id",
        nameKey: "name",
      },
      {
        key: "provider",
        label: "Provider",
        idKey: "id",
        nameKey: "name",
      },
      {
        key: "employee",
        label: "Employee",
        idKey: "id",
        nameKey: "name",
      },
    ],
    selectedReviewers: [],
    showAddReviewer: false,
    role: "",
    sector: "",
    newSector: false,
    newRole: false,
    showSectorRoleForm: false,
    attachmentSortBy: "createdStamp",
    attachmentSortOrder: "DESC",
    MAX_CHAR_LIMIT: 50000,
    selectedFileToView: {},
    showFileData: false,
    showUsernameDialog: false
  };

  clearUserName = () => {
    var data = { ...this.state.profileData };
    data.createdByUser = "";
    this.setState({
      profileData: data,
    });
  }
  openSearchUsernameDialog = () => {
    this.setState({
      showUsernameDialog: true
    });
  }
  onCloseUsernameDialog = () => {
    this.setState({
      showUsernameDialog: false
    });
  }

  selectUser = (user) => {
    var data = { ...this.state.profileData };
    data.createdByUser = user.userId;
    this.setState({
      profileData: data,
      showUsernameDialog: false
    });
  }

  componentDidMount() {
    if (this.props.newLeadOrCustomer) {
      this.setState({
        tabValue: 0,
      });
    }
    this.setState({
      loading: true,
    });
    var modules = JSON.parse(localStorage.getItem("modules"));
    this.setState({ modules: modules ? modules : {} });
    var shippingAddress = {};
    if (this.props.profileData.shipping.length > 0) {
      shippingAddress = this.props.profileData.shipping[0];
    } else {
      shippingAddress = {
        zip: "",
        country: this.props.defaultCountry,
        city: "",
        accountName: "",
        phoneMechId: "",
        postalMechId: "",
        phone: "",
        isPrimary: true,
        attention: "",
        street1: "",
        street2: "",
        state: "",
      };
    }
    if (this.props.profileData && this.props.profileData.shipping) {
      var shipping = this.props.profileData.shipping;
      if (Array.isArray(shipping)) {
        if (shipping.length > 0) {
          if (shipping[0].state) {
            if (shipping[0].country) {
              this.setStateListChange(shipping[0].country);
              this.setShippingStateName(shipping[0].country, shipping[0].state);
            } else {
              this.setStateListChange(this.props.defaultCountry);
              this.setState({
                stateName: shipping[0].state,
                loading: false,
              });
            }
          } else {
            this.setStateListChange(this.props.defaultCountry);
            this.setState({
              stateName: "",
              loading: false,
              stateNameLoading: false,
            });
          }
        } else {
          this.setStateListChange(this.props.defaultCountry);
          this.setState({
            stateName: "",
            loading: false,
          });
        }
      } else {
        if (shipping.state) {
          if (shipping.country) {
            this.setStateListChange(shipping.country);
            this.setShippingStateName(shipping.country, shipping.state);
          } else {
            this.setStateListChange(this.props.defaultCountry);
            this.setState({
              stateName: shipping.state,
              loading: false,
            });
          }
        } else {
          this.setStateListChange(this.props.defaultCountry);
          this.setState({
            stateName: "",
            loading: false,
          });
        }
      }
    }
    this.setState(
      {
        profileData: this.props.profileData,
        shipping: shippingAddress,
        isManaged: this.props.isManaged,
        manageCustomerRequired: this.props.manageCustomerRequired,
        showFacilityPrefixName: this.props.isManaged ? false : true,
      },
      () => {
        if (this.state.profileData && this.state.profileData.ban) {
          this.getCustomerNotes(this.state.profileData.ban);
          this.getCustomerAssessment(this.state.profileData.partyId);
          this.getReviewers();
          if (window.location.pathname === "/manageLeads") {
            this.getCustomerSectorRole();
          }
        }
      },
    );
  }

  getCustomerSectorRole = () => {
    let jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = this.props.parentTenantId;
    }
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/party/${this.state.profileData.partyId}/attributes`,
      jsonData,
    )
      .then((res) => {
        var sectorIndex = res.data.findIndex((a) => a.name === "attrSector");
        var roleIndex = res.data.findIndex((a) => a.name === "attrRole");
        if (sectorIndex > -1) {
          this.setState({
            sector: res.data[sectorIndex].value,
            newSector: false,
          });
        } else {
          this.setState({
            newSector: true,
          });
        }
        if (roleIndex > -1) {
          this.setState({
            role: res.data[roleIndex].value,
            newRole: false,
          });
        } else {
          this.setState({
            newRole: true,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  onChange = (e) => {
    const { t } = this.props;
    this.props.setErrorMessage("", false);
    let profileData = { ...this.state.profileData };
    profileData[e.target.name] = e.target.value;

    let banValue = profileData.ban;
    if (banValue.length > 20) {
      this.props.setErrorMessage(
        t("CUSTOMER_BAN_VALIDATION_ERROR_MESSAGE"),
        false,
      );
    }

    this.setState({
      profileData,
    });
  };

  toggleGeneralInfoForm = () => {
    var shippingAddress = JSON.parse(JSON.stringify(this.state.shipping));
    if (window.location.pathname.includes("/manageLeads")) {
      if (
        shippingAddress.country === "" ||
        shippingAddress.country === null ||
        shippingAddress.country === undefined
      ) {
        shippingAddress.country = this.props.defaultCountry;
        this.setStateListChange(this.props.defaultCountry);
      }
    }
    this.setState(
      {
        shipping: shippingAddress,
        showForm: !this.state.showForm,
        profileData: this.props.profileData,
        isManaged: this.props.isManaged,
        error: {},
        success: {},
      },
      () => {
        console.log("check shipping address", this.state.shipping);
      },
    );
  };

  daysArray = () => {
    let days = [];
    for (let i = 1; i < 32; i++) {
      days.push("" + i);
    }
    return days;
  };

  validateForm = () => {
    const error = {};
    const { t } = this.props;
    this.state.profileData.ban = this.state.profileData.ban.trim();
    if (!this.state.profileData.accountName) {
      error.accountName = t("ACCOUNT_NAME_IS_REQUIRED");
    }
    // if (!this.state.profileData.officePhone) {
    //     error.officePhone = t('OFFICE_PHONE_IS_REQUIRED');
    // } else if(!this.validateMobileNumber(this.state.profileData.officePhone)){
    //     error.officePhone = t('PHONE_IS_INVALID');
    // }
    if (this.state.profileData.officePhone) {
      if (!this.validateMobileNumber(this.state.profileData.officePhone)) {
        error.officePhone = t("PHONE_IS_INVALID");
      }
    }
    if (
      this.state.manageCustomerRequired &&
      this.state.showFacilityPrefixName &&
      this.state.isManaged
    ) {
      if (!this.state.facilityNamePrefix) {
        error.facilityNamePrefix = t("FACILITY_NAME_PREFIX_IS_REQUIRED");
      }
    }
    if (!this.state.profileData.ban) {
      error.ban = t("ACCOUNT_NUMBER_IS_REQUIRED");
    } else if (this.state.isInvalidBan) {
      error.ban = t("BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER");
    }
    // if (!this.state.profileData.firstName) {
    //     error.firstName = t('FIRST_NAME_IS_REQUIRED');
    // }
    // if (!this.state.profileData.lastName) {
    //     error.lastName = t('LAST_NAME_IS_REQUIRED');
    // }
    if (!this.state.profileData.email) {
      error.email = t("EMAIL_IS_REQUIRED");
    } else if (!/\S+@\S+\.\S+/.test(this.state.profileData.email)) {
      error.email = t("EMAIL_IS_INVALID");
    }
    if (!this.state.profileData.createdByUser && this.props.showMyCustomers) {
      error.createdBy = t("CREATED_BY_IS_REQUIRED");
    }
    if (this.state.profileData.mobilePhone) {
      if (!this.validateMobileNumber(this.state.profileData.mobilePhone)) {
        error.mobilePhone = t("PHONE_IS_INVALID");
      }
    }
    if (this.state.shipping.phone) {
      if (!this.validateMobileNumber(this.state.shipping.phone)) {
        error.phone = t("PHONE_IS_INVALID");
      }
    }
    if (!this.state.profileData.billingCloseDay) {
      error.billingCloseDay = t("BILLING_CYCLE_IS_REQUIRED");
    }
    if (!this.state.shipping.attention) {
      error.attention = t("ATTENTION_IS_REQUIRED");
    }
    if (!this.state.shipping.street1) {
      error.street1 = t("STREET1_IS_REQUIRED");
    }
    if (!this.state.shipping.city) {
      error.city = t("CITY_IS_REQUIRED");
    }
    // if (!this.state.shipping.zip) {
    //     error.zip = t('ZIP_IS_REQUIRED');
    // }
    // if (window.location.pathname.includes('/manageLeads')) { } else {
    if (!this.state.shipping.state) {
      error.state = t("STATE_IS_REQUIRED");
    }
    // }
    if (!this.state.shipping.country) {
      error.country = t("COUNTRY_IS_REQUIRED");
    }
    this.setState({ error });
    console.log("check error", error);
    this.setState({
      loading: false,
    });

    // const { t } = this.props;
    // this.state.profileData.ban = this.state.profileData.ban.trim();
    // if (!this.state.profileData.accountName || !this.state.profileData.officePhone ||
    //     !this.state.profileData.email ||
    //     !this.state.profileData.billingCloseDay || !this.state.profileData.ban ||
    //     !this.state.shipping.attention || !this.state.shipping.street1 ||
    //     !this.state.shipping.city || !this.state.shipping.zip || !this.state.shipping.state ||
    //     !this.state.shipping.country) {
    //     this.props.setErrorMessage(t('MANDATORY_FIELDS_MESSAGE'), false);
    //     this.setState({
    //         loading: false
    //     })
    //}
    if (Object.keys(error).length === 0) {
      return true;
    }
  };

  updateGeneralInfo = () => {
    var facilityNamePrefix = JSON.parse(
      JSON.stringify(this.state.facilityNamePrefix),
    );
    this.setState({
      loading: true,
    });
    if (this.validateForm()) {
      let data = {
        contact: {
          firstName: this.state.profileData.firstName,
          lastName: this.state.profileData.lastName,
          partyId: this.state.profileData.partyId,
          officePhone: this.state.profileData.officePhone
            ? this.state.profileData.officePhone
            : "",
          mobilePhone: this.state.profileData.mobilePhone,
          email: this.state.profileData.email,
          emailMechId: this.state.profileData.emailMechId,
          mobilePhoneMechId: this.state.profileData.mobilePhoneMechId,
          officePhoneMechId: this.state.profileData.officePhoneMechId,
          billingCloseDay: this.state.profileData.billingCloseDay,
          createdByUser: this.state.profileData.createdByUser,
        },
        billing: {
          attention: "",
          phone: "",
          street1: "",
          street2: "",
          city: "",
          state: "",
          zip: "",
          country: "",
        },
        shipping: {
          attention: this.state.shipping.attention,
          phone: this.state.shipping.phone ? this.state.shipping.phone : "",
          phoneMechId: this.state.shipping.phoneMechId
            ? this.state.shipping.phoneMechId
            : "",
          street1: this.state.shipping.street1,
          street2: this.state.shipping.street2
            ? this.state.shipping.street2
            : "",
          city: this.state.shipping.city,
          state: this.state.shipping.state,
          zip: this.state.shipping.zip,
          country: this.state.shipping.country,
          postalMechId: this.state.shipping.postalMechId,
        },
        banDetails: {
          accountName: this.state.profileData.accountName,
          ban: this.state.profileData.ban,
          isManaged: this.state.isManaged,
        },
      };
      if (data.banDetails.isManaged && this.state.showFacilityPrefixName) {
        data.banDetails.facilityNamePrefix = facilityNamePrefix;
      }
      if (!this.props.showMyCustomers) {
        delete data.contact.createdByUser;
      }
      this.submitData(data);
    }
  };

  submitData = (data) => {
    this.setState({
      loading: true,
    });
    BusApiCall("POST", `${constants.busInternalUrl}/customers`, data)
      .then((res) => {
        if (res.data.responseMessage === "success") {
          if (window.location.pathname.includes("/manageLeads")) {
            this.props.setErrorMessage(
              this.props.t("LEAD_UPDATED_SUCCESSFULLY"),
              true,
            );
          } else {
            this.props.setErrorMessage("Account updated successfully", true);
          }
          let prData = {
            officePhone: this.state.profileData.officePhone,
            mobilePhone: this.state.profileData.mobilePhone,
            email: this.state.profileData.email,
            billingCloseDay: this.state.profileData.billingCloseDay,
            accountName: this.state.profileData.accountName,
          };
          this.props.updateProfileData(prData);
          this.props.getCustomersHierarchy();
          this.setState({
            showForm: !this.state.showForm,
            loading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  setCountryName = (country) => {
    var list = this.props.countriesList;
    var index = list.findIndex((a) => a.id === country);
    if (index > -1) {
      return list[index].name;
    } else {
      return country;
    }
    // var list = stateCode.country;
    // for (var i = 0; i < list.length; i++) {
    //     if (list[i].abbreviation === country) {
    //         return list[i].name;
    //     }
    //     else {
    //         return country;
    //     }
    // }
  };

  setShippingStateName = (country, state) => {
    let jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = this.props.parentTenantId;
    }
    this.setState({ stateNameLoading: true });
    getStateName(country, state, jsonData)
      .then((res) => {
        this.setState({
          stateName: res,
          stateNameLoading: false,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          stateName: state,
          stateNameLoading: false,
          loading: false,
        });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("FAILED_TO_LOAD_STATES"),
            false,
          );
        }
      });
  };

  updateShippingAddress = (e) => {
    this.props.setErrorMessage("", false);
    let shipping = { ...this.state.shipping };
    shipping[e.target.name] = e.target.value;
    if (e.target.name === "country") {
      shipping["state"] = "";
    }

    this.setState({
      shipping,
    });
  };

  setStateListChange = (country) => {
    this.setState({
      loading: true,
    });
    let jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = this.props.parentTenantId;
    }
    getStatesList(country, jsonData)
      .then((res) => {
        this.setState({
          statesList: res,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("FAILED_TO_LOAD_STATES"),
            false,
          );
        }
      });
  };

  validateMobileNumber = (mobileNumber) => {
    const mobileNumberRegex =
      /^[+]?[0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$|^[\+][1][-][0-9]{1,3}[-\s.]?[0-9]{1,3}[-\s.]?[0-9]{1,4}$/;
    if (!mobileNumberRegex.test(mobileNumber)) {
      return false;
    }
    return true;
  };
  toggleManaged = (value) => {
    this.setState({
      isManaged: value,
    });
  };
  onChangeFacility = (e) => {
    var value = e.target.value;
    this.setState({
      facilityNamePrefix: value,
    });
  };
  // truncate = (value) => {
  //     return value.length > 86 ? value.substring(0, 83) + "..." : value;
  // }

  onChangeNotes = (state) => {
    var localisedNotes = [...this.state.localisedCustomerNote];
    localisedNotes[0].text = state;
    this.setState({
      customerNote: state,
      localisedCustomerNote: localisedNotes,
    })
    return;
    const contentState = state.getCurrentContent();
    const oldContent = this.state.notesState.getCurrentContent();
    if (
      contentState === oldContent ||
      contentState.getPlainText().length <= this.state.MAX_CHAR_LIMIT
    ) {
      var localisedNotes = [...this.state.localisedCustomerNote];
      localisedNotes[0].text = JSON.stringify(
        convertToRaw(state.getCurrentContent()),
      );
      localisedNotes[0].text = state;

      this.setState({
        // notesState: state,
        customerNote: state,
        localisedCustomerNote: localisedNotes,
      });
    } else {
      const editorState = EditorState.moveFocusToEnd(
        EditorState.push(
          this.state.notesState,
          ContentState.createFromText(oldContent.getPlainText()),
        ),
      );
      this.setState({ editorState });

      var data = {
        limit: this.state.MAX_CHAR_LIMIT,
      };
      this.props.setErrorMessage(
        this.props.t("MAX_CHAR_ALLOWED_ERROR", { data }),
        false,
      );
    }
    // var localisedNotes = [...this.state.localisedCustomerNote];
    // localisedNotes[0].text = JSON.stringify(convertToRaw(state.getCurrentContent()));

    // this.setState({
    //     notesState: state,
    //     customerNote: JSON.stringify(convertToRaw(state.getCurrentContent())),
    //     localisedCustomerNote: localisedNotes
    // })
  };

  getCustomerNotes = (id) => {
    this.setState({
      loading: true,
    });
    let jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = this.props.parentTenantId;
    }
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/customers/${UriEncode(id)}/notes`,
      jsonData,
    )
      .then((res) => {
        if (
          res.data &&
          res.data.localisedCustomerNote &&
          res.data.localisedCustomerNote.length > 0
        ) {
          this.setState({
            customerNote: res.data.customerNote
              ? res.data.customerNote
              : '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            originalCustomerNote: res.data.customerNote
              ? res.data.customerNote
              : '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            localisedCustomerNote: res.data.localisedCustomerNote
              ? res.data.localisedCustomerNote
              : [
                {
                  locale: "en_US",
                  text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                },
              ],
            originalLocalisedCustomerNote: res.data.localisedCustomerNote
              ? res.data.localisedCustomerNote
              : [
                {
                  locale: "en_US",
                  text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                },
              ],
            // notesState: EditorState.createWithContent(
            //   convertFromRaw(JSON.parse(res.data.customerNote)),
            // ),
            // originalNotesState: EditorState.createWithContent(
            //   convertFromRaw(JSON.parse(res.data.customerNote)),
            // ),
            oldNotes: true,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  onSaveNotesData = () => {
    this.setState({
      loading: true,
      editNote: false,
    });
    var payload = {
      basicDetail: {
        customerNote: this.state.customerNote,
        localisedCustomerNote: this.state.localisedCustomerNote,
      },
    };
    // /cumulator/api/v4.4/customers/{accountNumber}/notes
    if (this.state.oldNotes) {
      BusApiCall(
        "PUT",
        `${constants.busV44UrlPublic}/customers/${UriEncode(this.state.profileData.ban)}/notes`,
        payload,
      )
        .then((res) => {
          this.props.setErrorMessage(
            window.location.pathname === "/manageLeads"
              ? this.props.t("LEAD_NOTES_UPDATED")
              : this.props.t("CUSTOMER_NOTES_UPDATED"),
            true,
          );
          this.setState({
            customerNote: res.data.customerNote
              ? res.data.customerNote
              : '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            originalCustomerNote: res.data.customerNote
              ? res.data.customerNote
              : '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            localisedCustomerNote: res.data.localisedCustomerNote
              ? res.data.localisedCustomerNote
              : [
                {
                  locale: "en_US",
                  text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                },
              ],
            originalLocalisedCustomerNote: res.data.localisedCustomerNote
              ? res.data.localisedCustomerNote
              : [
                {
                  locale: "en_US",
                  text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                },
              ],
            // notesState: EditorState.createWithContent(
            //   convertFromRaw(JSON.parse(res.data.customerNote)),
            // ),
            // originalNotesState: EditorState.createWithContent(
            //   convertFromRaw(JSON.parse(res.data.customerNote)),
            // ),
            loading: false,
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
        });
    } else {
      BusApiCall(
        "POST",
        `${constants.busV44UrlPublic}/customers/${UriEncode(this.state.profileData.ban)}/notes`,
        payload,
      )
        .then((res) => {
          this.props.setErrorMessage(
            window.location.pathname === "/manageLeads"
              ? this.props.t("LEAD_NOTES_ADDED")
              : this.props.t("CUSTOMER_NOTES_ADDED"),
            true,
          );
          this.setState({
            customerNote: res.data.customerNote
              ? res.data.customerNote
              : '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            originalCustomerNote: res.data.customerNote
              ? res.data.customerNote
              : '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
            localisedCustomerNote: res.data.localisedCustomerNote
              ? res.data.localisedCustomerNote
              : [
                {
                  locale: "en_US",
                  text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                },
              ],
            originalLocalisedCustomerNote: res.data.localisedCustomerNote
              ? res.data.localisedCustomerNote
              : [
                {
                  locale: "en_US",
                  text: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
                },
              ],
            // notesState: EditorState.createWithContent(
            //   convertFromRaw(JSON.parse(res.data.customerNote)),
            // ),
            // originalNotesState: EditorState.createWithContent(
            //   convertFromRaw(JSON.parse(res.data.customerNote)),
            // ),
            oldNotes: true,
            loading: false,
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
          });
        });
    }
  };

  cancelNotesEditing = () => {
    this.setState({
      customerNote: this.state.originalCustomerNote,
      notesState: this.state.originalNotesState,
      localisedCustomerNote: this.state.originalLocalisedCustomerNote,
      editNote: false,
    });
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  getCustomerAssessment = () => {
    let jsonData = {};
    this.setState({ assessmentLoading: true });
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = this.props.parentTenantId;
    }
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/customers/${UriEncode(this.state.profileData.partyId)}/attachments?sortBy=${this.state.attachmentSortBy}&sortOrder=${this.state.attachmentSortOrder}`,
      jsonData,
    )
      .then((res) => {
        if (res && res.data && res.data.attachments) {
          this.setState({
            attachments: res.data.attachments,
            loading: false,
            assessmentLoading: false,
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          assessmentLoading: false,
        });
      });
  };

  handleAttachmentSort = (sortBy) => {
    if (this.state.attachmentSortOrder === "ASC") {
      this.setState(
        {
          attachmentSortOrder: "DESC",
          loading: true,
        },
        () => {
          this.getCustomerAssessment();
        },
      );
    } else {
      this.setState(
        {
          attachmentSortOrder: "ASC",
          loading: true,
        },
        () => {
          this.getCustomerAssessment();
        },
      );
    }
  };

  onChangeAssesment = (e) => {
    var tempAssessment = { ...this.state.assessmentData };
    tempAssessment.name = e.target.value;
    var error = { ...this.state.uploadAssesmentError };
    error.show = false;
    this.setState({
      uploadAssesmentError: error,
      assessmentData: tempAssessment,
    });
  };

  onDocumentUpload = (event) => {
    let format = event.target.files[0].name
      .substring(event.target.files[0].name.lastIndexOf(".") + 1)
      .toLowerCase();
    let itemType = event.target.files[0].type;
    let fileSize = event.target.files[0].size;
    if (fileSize > 5242880) {
      var error = { ...this.state.uploadAssesmentError };
      error.show = true;
      error.msg =
        event.target.files[0].name + " " + this.props.t("LARGE_FILE_ERROR");
      this.setState({
        uploadAssesmentError: error,
      });
      return;
    }
    if (
      format === "pdf" ||
      format === "jpg" ||
      format === "jpeg" ||
      format === "png"
    ) {
      var error = { ...this.state.uploadAssesmentError };
      error.show = false;
      this.setState({
        uploadAssesmentError: error,
      });
      this.setState({
        loading: true,
      });
      let selectedFile = event.target.files;
      let file = null;
      let fileName = "";
      //Check File is not Empty
      if (selectedFile.length > 0) {
        // Select the very first file from list
        let fileToLoad = selectedFile[0];
        fileName = fileToLoad.name;
        // FileReader function for read the file.
        let fileReader = new FileReader();
        // Onload of file read the file content
        fileReader.onload = function (fileLoadedEvent) {
          var tempFile = fileLoadedEvent.target.result;
          file = tempFile.split(",")[1];
        };
        // Convert data to base64
        fileReader.readAsDataURL(fileToLoad);
      }
      setTimeout(() => {
        var tempAssessment = { ...this.state.assessmentData };
        tempAssessment.data = file;
        tempAssessment.fileName = fileName;
        tempAssessment.format = itemType;
        this.setState({
          assessmentData: tempAssessment,
          loading: false,
        });
      }, 2000);
    } else {
      var error = { ...this.state.uploadAssesmentError };
      error.show = true;
      error.msg = this.props.t("INVALID_FILE_FORMAT");
      this.setState({
        uploadAssesmentError: error,
      });
    }
  };

  uploadAssesment = () => {
    if (this.state.assessmentData.data && this.state.assessmentData.name) {
      var payload = {};
      payload.document = {
        data: this.state.assessmentData.data,
        format: this.state.assessmentData.format,
        name: this.state.assessmentData.name,
      };
      // payload.reviewers = this.state.selectedReviewers;

      // Transform reviewers into a tree structure for the backend
      const transformedReviewers = this.state.selectedReviewers.reduce(
        (acc, reviewer) => {
          // Find existing role group or create new one
          let roleGroup = acc.find((group) => group.id === reviewer.roleId);

          if (!roleGroup) {
            roleGroup = {
              name: reviewer.role,
              id: reviewer.roleId,
              employees: [],
              providerDetails: {
                id: "",
                name: "",
                employees: [],
              },
            };
            acc.push(roleGroup);
          }
          if (reviewer.providerId) {
            roleGroup.providerDetails = {
              id: reviewer.providerId,
              name: reviewer.providerName,
              employees: [
                ...roleGroup.providerDetails.employees,
                {
                  name: reviewer.employee,
                  id: reviewer.employeeId,
                },
              ],
            };
          } else {
            // Add employee to role group for sales_rep
            roleGroup.employees.push({
              name: reviewer.employee,
              id: reviewer.employeeId,
            });
          }

          return acc;
        },
        [],
      );

      payload.reviewers = transformedReviewers;
      payload.customerType =
        window.location.pathname === "/manageLeads" ? "LEAD" : "CUSTOMER";
      if (this.state.attachments && this.state.attachments.length > 0) {
        var isDuplicateFile = this.state.attachments.some(
          (x) =>
            x.name.toLowerCase() ===
            this.state.assessmentData.name.toLowerCase(),
        );
        if (isDuplicateFile) {
          var error = { ...this.state.uploadAssesmentError };
          error.show = true;
          error.msg = this.props.t("DUPLICATE_ATTACHMENT_NAME");
          this.setState({
            uploadAssesmentError: error,
          });
          return;
        }
      }
      this.setState({
        loading: true,
        showUploadDailog: false,
      });
      BusApiCall(
        "POST",
        `${constants.busV44UrlPublic}/customers/${UriEncode(this.state.profileData.partyId)}/attachments`,
        payload,
      )
        .then((res) => {
          this.getCustomerAssessment();
          this.props.setErrorMessage(
            this.props.t("ASSESSMENT_UPLOADED_SUCCESSFULLY"),
            true,
          );
          this.setState({
            assessmentData: {
              name: "",
              data: "",
              format: "",
              fileName: "",
            },
            showUploadDailog: false,
            // loading: false
          });
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
            showUploadDailog: false,
            assessmentData: {
              name: "",
              data: "",
              format: "",
              fileName: "",
            },
          });
        });
    } else {
      var error = { ...this.state.uploadAssesmentError };
      error.msg = this.props.t("ALL_FIELDS_REQUIRED");
      error.show = true;
      this.setState({
        uploadAssesmentError: error,
      });
    }
  };

  setImageExtension = (data) => {
    let decoded = atob(decodeURIComponent(data));
    var lowerCase = decoded.toLowerCase();
    var extension = "";
    if (lowerCase.indexOf("png") === 1) {
      extension = "png";
    } else if (
      lowerCase.indexOf("jpg") === 1 ||
      lowerCase.indexOf("jpeg") === 1
    ) {
      extension = "jpg";
    } else if (lowerCase.includes("svg")) {
      extension = "svg+xml";
    } else if (
      lowerCase.indexOf("tif") === 1 ||
      lowerCase.indexOf("tiff") === 1
    ) {
      extension = "tiff";
    } else {
      extension = "png";
    }
    return extension;
  };

  viewAttachmentFile = (item) => {
    if (item.attachment) {
      this.setState(
        {
          selectedFileToView: item,
        },
        () => {
          this.setState({
            showFileData: true,
          });
        },
      );
    } else {
      this.props.setErrorMessage("File not found " + item.contentId, false);
    }
  };

  openAttachmentFile = (item) => {
    this.setState({
      loading: true,
    });
    let jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = this.props.parentTenantId;
    }
    var title = item.name;
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/customers/${UriEncode(this.state.profileData.partyId)}/attachments/${item.contentId}`,
      jsonData,
    )
      .then((res) => {
        if (res.data.mimeType === "application/pdf") {
          // Convert pdf to array buffer
          var arrrayBuffer = this.base64ToArrayBuffer(
            res.data.data.replace("data:application/pdf;base64,", ""),
          );
          // Create pdf blob
          var blob = new Blob(
            [arrrayBuffer],
            { type: "application/pdf" },
            title,
          );
          // Create URL object and download
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement("a");
          link.href = url;
          // link.download = title + '.pdf';
          link.download = title;
          link.dispatchEvent(new MouseEvent("click"));
          this.setState({
            loading: false,
          });
        } else {
          var a = document.createElement("a");
          a.href = "data:" + res.data.mimeType + ";base64," + res.data.data;
          a.download = title;
          a.dispatchEvent(new MouseEvent("click"));
          this.setState({
            loading: false,
          });
        }

        // if (res.data.mimeType === 'application/pdf') {
        //     let pdfWindow = window.open("");
        //     pdfWindow.document.write(
        //         "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
        //         encodeURI(res.data.data) + "'></iframe>"
        //     )
        // } else {
        //     var image = new Image();
        //     image.src = 'data:' + res.data.mimeType + ';base64,' + res.data.data;
        //     image.style = 'width: 70%';
        //     image.style = 'hight: 70%';
        //     var w = window.open("");
        //     w.document.write(image.outerHTML);
        // }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
    // if (item.mimeType === 'application/pdf') {
    //     let pdfWindow = window.open("");
    //     pdfWindow.document.write(
    //         "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
    //         encodeURI(item.attachment) + "'></iframe>"
    //     )
    // } else {
    //     var image = new Image();
    //     image.src = 'data:' + item.mimeType + ';base64,' + item.attachment;
    //     image.style = 'width: 100%';
    //     var w = window.open("");
    //     w.document.write(image.outerHTML);
    // }
  };

  // Covert base64 to array buffer
  base64ToArrayBuffer = (base64) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  };

  deleteAttachment = (item) => {
    this.setState({
      attachmentToDelete: item,
      confirmDeleteAttachment: true,
    });
  };

  confirmDeleteAssesment = () => {
    this.setState({ loading: true });
    BusApiCall(
      "DELETE",
      `${constants.busV44UrlPublic}/customers/${UriEncode(this.state.profileData.partyId)}/attachments/${this.state.attachmentToDelete.contentId}`,
    )
      .then((res) => {
        this.getCustomerAssessment();
        this.setState({
          attachmentToDelete: {},
          confirmDeleteAttachment: false,
        });
        this.props.setErrorMessage(
          this.props.t("ASSESSMENT_DELETED_SUCCESSFULLY"),
          true,
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          attachmentToDelete: {},
          confirmDeleteAttachment: false,
        });
      });
  };
  handleChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  validateBanOnBlur = async () => {
    if (
      this.state.profileData.isTempCustCode &&
      this.state.profileData.ban
        .toLowerCase()
        .startsWith(this.state.profileData.tempCustCodePrefix.toLowerCase())
    ) {
      return;
    }
    if (this.state.profileData.ban) {
      this.setState({
        loading: true,
        isInvalidBan: false,
        error: {
          ...this.state.error,
          ban: "",
        },
      });
      await BusApiCall(
        "GET",
        `${constants.busInternalUrl}/customers/${this.state.profileData.ban}/validate`,
        {},
      )
        .then((res) => {
          if (res && res.data) {
            if (res.data.apiEnabled === "Y") {
              if (
                // res.data.code === 200 &&
                (res.data.status === "Active" ||
                  res.data.status === "Qualified")
              ) {
                // BAN exists in ooredoo, allow to create
                this.setState({
                  loading: false,
                  error: {
                    ...this.state.error,
                    ban: "",
                  },
                  isInvalidBan: false,
                });
                return true;
              } else {
                // not allowed
                this.setState({
                  loading: false,
                  error: {
                    ...this.state.error,
                    ban: this.props.t(
                      "BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER",
                    ),
                  },
                  isInvalidBan: true,
                });
                return false;
              }
            } else {
              // allow to create with natural flow
              this.setState({
                loading: false,
                error: {
                  ...this.state.error,
                  ban: "",
                },
                isInvalidBan: false,
              });
              return true;
            }
          } else {
            // not allowed
            this.setState({
              loading: false,
              error: {
                ...this.state.error,
                ban: this.props.t("BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER"),
              },
              isInvalidBan: true,
            });
            return false;
          }
        })
        .catch((err) => {
          // not allowed
          // togglePartialLoading(false);
          // setError({
          //     ...error,
          //     ban: t('BAN_NOT_FOUND_CANNOT_CREATE_NEW_CUSTOMER')
          // });
          // setInvalidBan(true);
          console.log("err", err);
          if (err.response && err.response.data && err.response.data.message) {
            // this.props.setErrorMessage(err.response.data.message, false)
            var msg = `${err.response.data.detail ? `${err.response.data.detail} : ` : ""}${err.response.data.message || ""}`;
            this.props.setErrorMessage(msg, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            loading: false,
            isInvalidBan: true,
          });
          return false;
        });
    }
  };

  verifyUserId(callback) {
    const userId = this.state.profileData.createdByUser;
    if (userId) {
      this.setState({
        partialLoading: true,
      });
      BusApiCall(
        "GET",
        `${constants.busInternalUrl}/users/verify?userId=${userId}`,
        {},
      )
        .then((res) => {
          if (res && res.data) {
            if (res.data.userExists) {
              //userId is valid
              // this.props.setErrorMessage(this.props.t('USER_ID_VERIFIED'), true)
              this.setState(
                {
                  success: {
                    ...this.state.success,
                    createdBy: this.props.t("USER_ID_VERIFIED"),
                  },
                  userVerified: true,
                  partialLoading: false,
                },
                callback,
              );
            } else {
              this.setState({
                error: {
                  ...this.state.error,
                  createdBy: this.props.t("INVALID_USER_ID"),
                },
                userVerified: false,
                partialLoading: false,
              });
            }
          }
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          this.setState({
            partialLoading: false,
            userVerified: false,
          });
        });
    }
  }

  handleUpdateGeneralInfo = async () => {
    const originalBan = this.props.profileData.ban;
    const currentBan = this.state.profileData.ban;
    const banChanged = originalBan !== currentBan;

    if (this.props.showMyCustomers) {
      if (!this.state.profileData.createdByUser) {
        this.setState({
          error: {
            ...this.state.error,
            createdBy: this.props.t("CREATED_BY_IS_REQUIRED"),
          },
        });
        return;
      }

      if (!this.state.userVerified || banChanged) {
        // If BAN changed, validate it
        if (banChanged) {
          const isValid = await this.validateBanOnBlur();
          if (this.state.error.ban || this.state.isInvalidBan) {
            return;
          }
        }

        // If username not verified, verify it and then update
        if (!this.state.userVerified) {
          this.verifyUserId(() => {
            if (this.state.userVerified) {
              this.updateGeneralInfo();
            }
          });
          return;
        }
      }

      this.updateGeneralInfo();
    } else {
      // Only check BAN validation for showMyCustomers feature disabled
      if (banChanged) {
        const isValid = await this.validateBanOnBlur();
        if (this.state.error.ban || this.state.isInvalidBan) {
          return;
        }
      }

      this.updateGeneralInfo();
    }
  };

  handleReviewerSelected = (reviewerData) => {
    // Check if reviewer already exists
    const isDuplicate = this.state.selectedReviewers.some(
      (r) => r.employeeId === reviewerData.employeeId,
    );

    if (!isDuplicate) {
      this.setState((prevState) => ({
        selectedReviewers: [...prevState.selectedReviewers, reviewerData],
      }));
    }
  };

  handleDeleteReviewer = (employeeId) => {
    this.setState((prevState) => ({
      selectedReviewers: prevState.selectedReviewers.filter(
        (r) => r.employeeId !== employeeId,
      ),
    }));
  };
  toggleAddReviewer = () => {
    this.setState((prevState) => ({
      showAddReviewer: !prevState.showAddReviewer,
    }));
  };

  getReviewers = () => {
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/passthru/GET_CUST_ASSESSMENT_PARTIES/endpoint`,
      {},
    )
      .then((res) => {
        if (res && res.data && Object.keys(res.data).length > 0) {
          this.setState({
            reviewers: res.data,
          });
        } else {
          this.setState({
            reviewers: [],
          });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          reviewers: [],
        });
      });
  };

  changeSectorRole = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  updateSectorRole = (type) => {
    if (type === "sector") {
      if (this.state.sector.trim() === "") {
        this.props.setErrorMessage(
          this.props.t("MANDATORY_FIELDS_MESSAGE"),
          false,
        );
        return;
      }
    }
    if (type === "role") {
      if (this.state.role.trim() === "") {
        this.props.setErrorMessage(
          this.props.t("MANDATORY_FIELDS_MESSAGE"),
          false,
        );
        return;
      }
    }
    this.setState({
      loading: true,
    });
    var payload = {};
    if (type === "sector") {
      payload = {
        name: "attrSector",
        description: "",
        value: this.state.sector,
      };
    }
    if (type === "role") {
      payload = {
        name: "attrRole",
        description: "",
        value: this.state.role,
      };
    }
    var newAttr = false;
    if (type === "sector") {
      if (this.state.newSector) {
        newAttr = true;
      }
    }
    if (type === "role") {
      if (this.state.newRole) {
        newAttr = true;
      }
    }
    BusApiCall(
      newAttr ? "POST" : "PATCH",
      `${constants.busV44UrlPublic}/party/${this.state.profileData.partyId}/attributes`,
      payload,
    )
      .then((res) => {
        if (type === "sector") {
          this.props.setErrorMessage(
            this.props.t("SECTOR_UPDATED_SUCCESSFULLY"),
            true,
          );
          this.setState({
            newSector: false,
            showSectorRoleForm: false,
          });
          this.getCustomerSectorRole("sector");
        }
        if (type === "role") {
          this.props.setErrorMessage(
            this.props.t("ROLE_UPDATED_SUCCESSFULLY"),
            true,
          );
          this.setState({
            newRole: false,
            showSectorRoleForm: false,
          });
          this.getCustomerSectorRole("role");
        }
        this.setState({
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };
  editSectorRole = () => {
    this.setState({
      showSectorRoleForm: true,
    });
  };

  render() {
    const { t } = this.props;
    const { error, success } = this.state;
    // const CustomTabs = withStyles({
    //     indicator: {
    //         //   backgroundColor: '#ff5722',
    //         backgroundColor: this.props.tenantData.color,
    //     },
    // })(Tabs);
    const { classes: jssClasses } = this.props;
    return (
      <div>
        {this.state.showForm ? (
          <div>
            <Box
              className="roundCorners"
              style={{ border: "1px solid lightgrey", padding: "1.5rem" }}
            >
              <Grid container spacing={2} style={{ marginTop: "-6px" }}>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.accountName}
                    helperText={error.accountName}
                    variant={"outlined"}
                    name={"accountName"}
                    size={"small"}
                    value={this.state.profileData.accountName}
                    placeholder={t("ACCOUNT_NAME") + " *"}
                    onChange={(event) => {
                      this.onChange(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          accountName: "",
                        },
                      });
                    }}
                  />
                </Grid>
                {window.location.pathname !== "/manageLeads" && (
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 6,
                    }}
                  >
                    <Input
                      error={!!error.ban}
                      helperText={error.ban}
                      variant={"outlined"}
                      name={"ban"}
                      size={"small"}
                      value={this.state.profileData.ban}
                      placeholder={t("ACCOUNT_NUMBER") + " *"}
                      onChange={(event) => {
                        this.onChange(event);
                        this.setState({
                          error: {
                            ...this.state.error,
                            ban: "",
                            isInvalidBan: false,
                          },
                        });
                      }}
                    // onBlur={e => this.validateBanOnBlur()}
                    />
                  </Grid>
                )}
                {this.state.manageCustomerRequired &&
                  this.state.modules &&
                  this.state.modules.module_inventory === "enabled" && (
                    <>
                      <Grid
                        item
                        style={{ padding: "8px", paddingTop: "12px" }}
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        <FormControlLabel
                          style={{ marginLeft: "auto", marginRight: "auto" }}
                          control={
                            <Checkbox
                              checked={this.state.isManaged}
                              onChange={() =>
                                this.toggleManaged(!this.state.isManaged)
                              }
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  this.toggleManaged(!this.state.isManaged);
                                }
                              }}
                              disabled={this.props.isManaged}
                            />
                          }
                        />
                        <span
                          style={{
                            position: "relative",
                            marginLeft: "5px",
                            fontSize: "14px",
                          }}
                        >
                          {t("IS_ACCOUNT_MANAGED")}
                        </span>
                      </Grid>
                      {this.state.showFacilityPrefixName && (
                        <Grid
                          item
                          style={{ padding: "8px", paddingTop: "12px" }}
                          size={{
                            xs: 12,
                            md: 6,
                          }}
                        >
                          <Input
                            inputClass={classes.inputClass}
                            error={!!error.facilityNamePrefix}
                            helperText={error.facilityNamePrefix}
                            size={"small"}
                            variant={"outlined"}
                            name={"facilityNamePrefix"}
                            disabled={!this.state.isManaged}
                            // style={{ marginTop: '10px' }}
                            placeholder={t("FACILITY_NAME_PREFIX") + " *"}
                            value={this.state.facilityNamePrefix}
                            onChange={(event) => {
                              this.onChangeFacility(event);
                              this.setState({
                                error: {
                                  ...this.state.error,
                                  facilityNamePrefix: "",
                                },
                              });
                            }}
                          />
                        </Grid>
                      )}
                    </>
                  )}
                {this.state.modules &&
                  this.state.modules.module_payment === "enabled" && ( //using payment because on the create screen this falls under the payment page and depends on payment module
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <FormControl
                        className="custom-select-input"
                        size={"small"}
                        variant={"outlined"}
                        error={!!error.billingCloseDay}
                        disabled
                      >
                        <InputLabel htmlFor="outlined-age-native-simple">
                          {this.props.t("BILLING_CLOSE_DAY") + " *"}
                        </InputLabel>
                        <Select
                          native
                          label="BILLING_CLOSE_DAY"
                          value={this.state.profileData.billingCloseDay}
                          onChange={(event) => {
                            this.onChange(event);
                          }}
                          inputProps={{
                            name: "billingCloseDay",
                            id: "outlined-age-native-simple",
                          }}
                        >
                          <option value="" disabled>
                            {this.props.t("BILLING_CLOSE_DAY") + " *"}
                          </option>
                          {this.daysArray().map((day) => (
                            <option key={day} value={day}>
                              {day}
                            </option>
                          ))}
                        </Select>
                        {error.billingCloseDay && (
                          <span
                            style={{
                              color: "#f44336",
                              marginLeft: "0px",
                              fontSize: "0.75rem",
                              marginTop: "4px",
                            }}
                          >
                            {error.billingCloseDay}
                          </span>
                        )}
                      </FormControl>
                    </Grid>
                  )}
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <h3>{t("CONTACT_DETAILS")} </h3>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.firstName}
                    helperText={error.firstName}
                    size={"small"}
                    variant={"outlined"}
                    name={"firstName"}
                    value={this.state.profileData.firstName}
                    placeholder={t("FIRST_NAME")}
                    onChange={(event) => {
                      this.onChange(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          firstName: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.lastName}
                    helperText={error.lastName}
                    size={"small"}
                    variant={"outlined"}
                    name={"lastName"}
                    value={this.state.profileData.lastName}
                    placeholder={t("LAST_NAME")}
                    onChange={(event) => {
                      this.onChange(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          lastName: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <InputPhone
                    inputClass={classes.inputClass}
                    error={!!error.officePhone}
                    helperText={error.officePhone}
                    variant={"outlined"}
                    name={"officePhone"}
                    size={"small"}
                    value={this.state.profileData.officePhone}
                    placeholder={t("OFFICE_PHONE")}
                    onChange={(event) => {
                      this.onChange(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          officePhone: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <InputPhone
                    inputClass={classes.inputClass}
                    error={!!error.mobilePhone}
                    helperText={error.mobilePhone}
                    variant={"outlined"}
                    name={"mobilePhone"}
                    size={"small"}
                    placeholder={t("MOBILE_PHONE")}
                    value={this.state.profileData.mobilePhone}
                    onChange={(event) => {
                      this.onChange(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          mobilePhone: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.email}
                    helperText={error.email}
                    variant={"outlined"}
                    name={"email"}
                    size={"small"}
                    value={this.state.profileData.email}
                    placeholder={t("EMAIL") + " *"}
                    onChange={(event) => {
                      this.onChange(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          email: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <h3>{t("SHIPPING_ADDRESS")} </h3>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.attention}
                    helperText={error.attention}
                    size={"small"}
                    variant={"outlined"}
                    name={"attention"}
                    value={this.state.shipping.attention}
                    placeholder={t("ATTENTION") + " *"}
                    onChange={(event) => {
                      this.updateShippingAddress(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          attention: "",
                        },
                      });
                    }}
                  />
                </Grid>{" "}
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <InputPhone
                    error={!!error.phone}
                    helperText={error.phone}
                    size={"small"}
                    variant={"outlined"}
                    name={"phone"}
                    value={this.state.shipping.phone}
                    placeholder={t("PHONE")}
                    onChange={(event) => {
                      this.updateShippingAddress(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          phone: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.street1}
                    helperText={error.street1}
                    size={"small"}
                    variant={"outlined"}
                    name={"street1"}
                    value={this.state.shipping.street1}
                    placeholder={t("STREET1") + " *"}
                    onChange={(event) => {
                      this.updateShippingAddress(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          street1: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    name={"street2"}
                    value={this.state.shipping.street2}
                    placeholder={t("STREET2")}
                    onChange={(event) => {
                      this.updateShippingAddress(event);
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.city}
                    helperText={error.city}
                    name={"city"}
                    size={"small"}
                    variant={"outlined"}
                    value={this.state.shipping.city}
                    placeholder={t("CITY") + " *"}
                    onChange={(event) => {
                      this.updateShippingAddress(event);
                      this.setState({
                        error: {
                          ...this.state.error,
                          city: "",
                        },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <Input
                    error={!!error.zip}
                    helperText={error.zip}
                    name={"zip"}
                    size={"small"}
                    variant={"outlined"}
                    value={this.state.shipping.zip}
                    placeholder={t("ZIP")}
                    onChange={(event) => {
                      this.updateShippingAddress(event);
                      // this.setState({
                      //     error: {
                      //         ...this.state.error,
                      //         zip: "",
                      //     },
                      // });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <FormControl
                    variant={"outlined"}
                    className="custom-select-input"
                    size={"small"}
                  >
                    <InputLabel htmlFor="country">{t("COUNTRY")} *</InputLabel>
                    <Select
                      native
                      label="COUNTRY"
                      value={this.state.shipping.country}
                      inputProps={{
                        name: "country",
                        id: "country",
                      }}
                      onChange={(event) => {
                        this.updateShippingAddress(event);
                        this.setStateListChange(event.target.value);
                      }}
                    >
                      {/* <option value="" disabled>Select Country *</option> */}
                      {/* {stateCode.country.map(a => (
                                                    <option key={a.abbreviation} value={a.abbreviation}>{a.name}</option>
                                                ))} */}
                      {this.props.countriesList.map((a) => (
                        <option key={a.id} value={a.id}>
                          {a.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <FormControl
                    variant={"outlined"}
                    className="custom-select-input"
                    size={"small"}
                  >
                    <InputLabel htmlFor="state">{t("STATE")} *</InputLabel>
                    <Select
                      native
                      label="STATE"
                      onChange={(event) => {
                        this.updateShippingAddress(event);
                        this.setState({
                          error: {
                            ...this.state.error,
                            state: "",
                          },
                        });
                      }}
                      value={this.state.shipping.state}
                      error={!!error.state}
                      helperText={error.state}
                      inputProps={{
                        name: "state",
                        id: "state",
                      }}
                    >
                      <option value="" disabled></option>
                      {/* {stateCode.state[this.state.shipping.country].map(a => (
                                                    <option key={a.abbreviation} value={a.abbreviation}>{a.name}</option>
                                                ))} */}
                      {this.state.statesList.map((a) => (
                        <option key={a.id} value={a.id}>
                          {" "}
                          {a.name}
                        </option>
                      ))}
                    </Select>
                    <FormHelperText style={{ color: "#f44336" }}>
                      {error.state}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                {this.props.showMyCustomers && (
                  <>
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      <h3>{t("CREATED_BY")} </h3>
                    </Grid>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <Input
                        error={!!error.createdBy}
                        helperText={success.createdBy || error.createdBy || ""}
                        variant={"outlined"}
                        name={"createdByUser"}
                        size={"small"}
                        value={this.state.profileData.createdByUser}
                        placeholder={t("USERNAME") + " *"}
                        onChange={(event) => {
                          this.onChange(event);
                          const newError = { ...this.state.error };
                          delete newError.createdBy;
                          const newSuccess = { ...this.state.success };
                          delete newSuccess.createdBy;
                          this.setState({
                            error: newError,
                            success: newSuccess,
                            userVerified: false,
                          });
                        }}
                        onBlur={() => {
                          this.setState(
                            (prevState) => ({
                              profileData: {
                                ...prevState.profileData,
                                createdByUser:
                                  prevState.profileData.createdByUser.trim(),
                              },
                            }),
                            () => {
                              // this.verifyUserId();
                            },
                          );
                        }}
                        FormHelperTextProps={{
                          className: success.createdBy
                            ? "success-helper-text"
                            : "",
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {this.state.profileData.createdByUser && (
                                <IconButton onClick={() => this.clearUserName()} edge="end">
                                  <ClearIcon />
                                </IconButton>
                              )}
                              <IconButton edge="end" onClick={() => this.openSearchUsernameDialog()}>
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </>
                )}
                <Grid
                  item
                  align="right"
                  size={{
                    xs: 12,
                  }}
                >
                  <Button
                    className={"buttonSecondary"}
                    style={{ marginRight: "10px" }}
                    onClick={() => this.toggleGeneralInfoForm()}
                  >
                    {t("CANCEL")}
                  </Button>
                  <Button onClick={this.handleUpdateGeneralInfo}>
                    {t("UPDATE")}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </div>
        ) : (
          <>
            {this.props.isChild ? (
              <>
                <div
                  style={{
                    padding: "1rem 1rem 0rem 1rem",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ width: "60%" }}>
                    {this.state.profileData.accountName && (
                      <h3>
                        {this.props.screen === "checkout"
                          ? t("SHIPPING")
                          : `${this.state.profileData.accountName} ${this.props.providerType === "SALES_CHNL_PROVIDER" && this.state.profileData?.ban ? `(${this.state.profileData.ban})` : ""}`}
                      </h3>
                    )}
                  </span>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <span style={{ alignContent: "center" }}>
                      {" "}
                      {this.state.isManaged === true && (
                        <Chip
                          size="normal"
                          style={{ fontWeight: "600" }}
                          label={"Managed"}
                        />
                      )}
                    </span>
                    <span>
                      {this.state.profileData.isGroup &&
                        this.props.userPerms.includes("PARTYMGR_ADMIN") &&
                        this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                        this.props.providerType === "SALES_CHNL_PROVIDER" && (
                          <Button
                            className={"buttonSecondary"}
                            style={{ marginLeft: "1rem" }}
                            onClick={(e) =>
                              this.props.addChildItem(
                                e,
                                this.state.profileData.partyId,
                              )
                            }
                          >
                            <span
                              style={{
                                marginRight: ".25rem",
                                verticalAlign: "middle",
                              }}
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {t("ADD_SUB_CUSTOMER")}
                          </Button>
                        )}
                    </span>
                  </div>
                </div>
                <Grid container spacing={1}>
                  <Grid
                    item
                    style={{ paddingBottom: "1rem" }}
                    size={{
                      xs: 12,
                    }}
                  >
                    <Box className={classes.tabUnderLine}>
                      <Tabs
                        indicatorColor="primary"
                        // indicatorColor={this.props.tenantData.color}
                        textColor="#0E121B"
                        scrollButtons="auto"
                        // onChange={this.handleChange}
                        value={0}
                        className={classes.createPackageTabs}
                      >
                        <Tab value={0} label={t("GENERAL_INFORMATION")} />
                      </Tabs>
                    </Box>
                  </Grid>
                  <Box paddingTop={3} /> {/*Space added*/}
                </Grid>

                {/* <Card variant="outlined" style={{ borderRadius: "8px", width: '95%' }}> */}
                <div>
                  <Box
                    className="roundCorners"
                    style={{
                      border: "1px solid lightgrey",
                      marginTop: "1rem",
                      padding: "1.5rem",
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 4,
                        }}
                      >
                        <h3
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                            float: "left",
                            width: "60%",
                          }}
                        >
                          {t("INFO")}
                        </h3>
                      </Grid>
                      <Grid
                        item
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        size={{
                          xs: 12,
                          md: 8,
                        }}
                      >
                        <span style={{ float: "right", marginLeft: "15px" }}>
                          {this.props.screen !== "checkout" && (
                            <>
                              {this.props.userPerms.includes(
                                "PARTYMGR_ADMIN",
                              ) &&
                                (this.props.loggedInUserType !==
                                  "ECOMMERCE_CUSTOMER" ||
                                  this.props.loggedInUserId ===
                                  this.state.profileData.username) && (
                                  <Button
                                    className="buttonSecondary"
                                    onClick={(e) =>
                                      this.props.editChildItem(
                                        e,
                                        this.state.profileData,
                                      )
                                    }
                                  >
                                    <span style={{ marginRight: ".5rem" }}>
                                      <svg
                                        width="14"
                                        height="13"
                                        viewBox="0 0 13 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {t("EDIT")}
                                  </Button>
                                )}
                              {/* <Button>{t('EDIT')}</Button> */}
                            </>
                          )}
                        </span>
                      </Grid>
                      {this.state.profileData.partyType === "LOCATION" && (
                        <>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 3,
                            }}
                          >
                            <b>{t("IDENTIFIER")}</b>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            {this.state.profileData.locationDetails.identifier
                              ? this.state.profileData.locationDetails
                                .identifier
                              : "-"}
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 3,
                            }}
                          >
                            <b>{t("DESCRIPTION")}</b>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            {this.state.profileData.locationDetails.description
                              ? this.state.profileData.locationDetails
                                .description
                              : "-"}
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 3,
                            }}
                          >
                            <b>{t("POSITIONING")}</b>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            {this.state.profileData.locationDetails.positioning
                              ? this.state.profileData.locationDetails
                                .positioning
                              : "-"}
                          </Grid>
                        </>
                      )}
                      {this.state.profileData.username && (
                        <>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 3,
                            }}
                          >
                            <b>{t("USERNAME")}</b>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            {this.state.profileData.username}
                          </Grid>
                        </>
                      )}
                      {this.state.profileData.partyType !== "LOCATION" && (
                        <>
                          {this.state.profileData.shipping &&
                            this.state.profileData.shipping.length > 0 && (
                              <>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 3,
                                  }}
                                >
                                  <b>{t("SHIPPING_ADDRESS")}</b>
                                </Grid>
                                {Array.isArray(
                                  this.state.profileData.shipping,
                                ) &&
                                  this.state.profileData.shipping.length > 0 ? (
                                  <Grid
                                    item
                                    size={{
                                      xs: 12,
                                      md: 9,
                                    }}
                                  >
                                    {this.state.profileData.shipping[0]
                                      .street1 &&
                                      this.state.stateNameLoading ? (
                                      "Loading..."
                                    ) : (
                                      <>
                                        {this.state.profileData.shipping[0]
                                          .street1 &&
                                          this.state.profileData.shipping[0]
                                            .street1 !== "" &&
                                          this.state.profileData.shipping[0]
                                            .street1 + ", "}
                                        {this.state.profileData.shipping[0]
                                          .street2 &&
                                          this.state.profileData.shipping[0]
                                            .street2 !== "" &&
                                          this.state.profileData.shipping[0]
                                            .street2 + ", "}
                                        {this.state.profileData.shipping[0]
                                          .city &&
                                          this.state.profileData.shipping[0]
                                            .city !== "" &&
                                          this.state.profileData.shipping[0]
                                            .city + ", "}
                                        {this.state.stateName}&nbsp;
                                        {this.state.profileData.shipping[0]
                                          .zipCode
                                          ? this.state.profileData.shipping[0]
                                            .zipCode &&
                                          this.state.profileData.shipping[0]
                                            .zipCode !== "" &&
                                          this.state.profileData.shipping[0]
                                            .zipCode + ", "
                                          : this.state.profileData.shipping[0]
                                            .zip &&
                                          this.state.profileData.shipping[0]
                                            .zip !== "" &&
                                          this.state.profileData.shipping[0]
                                            .zip + ", "}
                                        {this.state.profileData.shipping[0]
                                          .country &&
                                          this.state.profileData.shipping[0]
                                            .country !== "" &&
                                          this.setCountryName(
                                            this.state.profileData.shipping[0]
                                              .country,
                                          )}
                                      </>
                                    )}
                                  </Grid>
                                ) : (
                                  <Grid
                                    item
                                    size={{
                                      xs: 12,
                                      md: 9,
                                    }}
                                  >
                                    {this.state.profileData.shipping
                                      .street1 && (
                                        <>
                                          {this.state.profileData.shipping
                                            .street1 + ", "}
                                          {this.state.profileData.shipping
                                            .street2 &&
                                            this.state.profileData.shipping
                                              .street2 !== "" &&
                                            this.state.profileData.shipping
                                              .street2 + ", "}
                                          {this.state.profileData.shipping.city +
                                            ", "}
                                          {this.state.stateName}&nbsp;
                                          {this.state.profileData.shipping.zipCode
                                            ? this.state.profileData.shipping
                                              .zipCode + ", "
                                            : this.state.profileData.shipping
                                              .zip + ", "}
                                          {this.setCountryName(
                                            this.state.profileData.shipping
                                              .country,
                                          )}
                                        </>
                                      )}
                                  </Grid>
                                )}
                              </>
                            )}
                          {(this.state.profileData.firstName ||
                            this.state.profileData.lastName) && (
                              <>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 3,
                                  }}
                                >
                                  <b>{t("CONTACT")}</b>
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 9,
                                  }}
                                >
                                  {this.state.profileData.firstName
                                    ? this.state.profileData.firstName
                                    : ""}{" "}
                                  {this.state.profileData.lastName
                                    ? this.state.profileData.lastName
                                    : ""}
                                </Grid>
                              </>
                            )}
                          {this.state.profileData.officePhone && (
                            <>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 3,
                                }}
                              >
                                <b>{t("PHONE")}</b>
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 9,
                                }}
                              >
                                {this.state.profileData.officePhone}
                              </Grid>
                            </>
                          )}
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 3,
                            }}
                          >
                            <b>{t("EMAIL")}</b>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            {this.state.profileData.email}
                          </Grid>
                          {/* {this.props.showMyCustomers &&  this.state.profileData.createdByUser &&
                                                    <>
                                                        <Grid item xs={12} md={3}>
                                                            <b>{t("CREATED_BY")}</b>
                                                        </Grid>
                                                        <Grid item xs={12} md={9}>
                                                            {this.state.profileData.createdByUser}
                                                        </Grid>
                                                    </>
                                                    } */}
                        </>
                      )}
                    </Grid>
                  </Box>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    padding: "0rem 0rem 0rem 0.5rem",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span style={{ width: "60%" }}>
                    {this.state.profileData.accountName && (
                      <h3>
                        {this.props.screen === "checkout"
                          ? t("SHIPPING")
                          : `${this.state.profileData.accountName} ${this.props.providerType ===
                            "SALES_CHNL_PROVIDER" &&
                            this.state.profileData?.ban
                            ? window.location.pathname === "/manageLeads"
                              ? ``
                              : `(${this.state.profileData.ban})`
                            : ""
                          }`}
                      </h3>
                    )}
                  </span>
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <span style={{ alignContent: "center" }}>
                      {" "}
                      {this.state.isManaged === true && (
                        <Chip
                          size="normal"
                          style={{ fontWeight: "600" }}
                          label={"Managed"}
                        />
                      )}
                    </span>
                    <span
                      style={{ marginLeft: "15px", alignContent: "center" }}
                    >
                      {this.props.screen !== "checkout" && (
                        <>
                          {/* <Button>{t('EDIT')}</Button> */}
                          {/* <Button onClick={(e) => this.props.addChildItem(e, this.state.profileData.partyId)} style={{ marginLeft: '15px' }}>Add</Button> */}
                          {this.props.userPerms.includes("PARTYMGR_ADMIN") &&
                            this.props.loggedInUserType !==
                            "ECOMMERCE_CUSTOMER" &&
                            this.props.providerType ===
                            "SALES_CHNL_PROVIDER" && (
                              <>
                                {/* {window.location.pathname === '/manageLeads' &&
                                                                    <Button
                                                                        className={"buttonSecondary"}
                                                                        onClick={(e) => this.props.promoteLead(e, this.state.profileData)}
                                                                        style={{ marginLeft: "1rem" }}
                                                                    >
                                                                        {t("PROMOTE_TO_CUSTOMER")}
                                                                    </Button>
                                                                } */}
                                {window.location.pathname !==
                                  "/manageLeads" && (
                                    <Button
                                      className={"buttonSecondary"}
                                      onClick={(e) =>
                                        this.props.addChildItem(
                                          e,
                                          this.state.profileData.partyId,
                                        )
                                      }
                                      style={{ marginLeft: "1rem" }}
                                    >
                                      <span
                                        style={{
                                          marginRight: ".25rem",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 12 12"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {t("ADD_SUB_CUSTOMER")}
                                    </Button>
                                  )}
                              </>
                            )}
                        </>
                      )}
                    </span>
                  </div>
                </div>
                <Grid container spacing={1}>
                  <Grid
                    item
                    style={{ paddingBottom: "1rem", overflow: "auto" }}
                    size={{
                      xs: 12,
                    }}
                  >
                    <Box
                      className={classes.tabUnderLine}
                      style={{ overflowX: "auto", whiteSpace: "nowrap" }}
                    >
                      <Tabs
                        indicatorColor="primary"
                        // textColor="primary"
                        textColor="#0E121B"
                        scrollButtons="auto"
                        onChange={this.handleChange}
                        value={this.state.tabValue}
                        className={classes.createPackageTabs}
                        variant="scrollable"
                      >
                        {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                          <Tab value={0} label={t("GENERAL_INFORMATION")} />
                        )}
                        {this.props.screen !== "checkout" &&
                          this.state.modules.module_payment === "enabled" &&
                          this.props.providerType === "SALES_CHNL_PROVIDER" && (
                            <Tab value={1} label={t("PAYMENT_METHODS")} />
                          )}
                        {this.props.screen !== "checkout" && (
                          <Tab value={2} label={t("NOTES")} />
                        )}
                        {this.props.screen !== "checkout" && (
                          <Tab value={3} label={t("ASSESSMENTS")} />
                        )}
                        {this.props.screen !== "checkout" &&
                          this.props.providerType === "SALES_CHNL_PROVIDER" &&
                          window.location.pathname !== "/manageLeads" && (
                            <Tab value={4} label={t("USERS")} />
                          )}
                        {this.props.screen !== "checkout" &&
                          this.props.providerType === "SALES_CHNL_PROVIDER" &&
                          window.location.pathname === "/manageLeads" && (
                            <Tab value={5} label={t("SECTOR_&_ROLE")} />
                          )}
                      </Tabs>
                    </Box>
                  </Grid>
                  <Box paddingTop={3} /> {/*Space added*/}
                </Grid>
                {this.state.tabValue === 5 && (
                  <div>
                    <div>
                      {this.state.showSectorRoleForm ? (
                        <Box
                          className="roundCorners"
                          style={{
                            border: "1px solid lightgrey",
                            padding: "1.5rem",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              style={{ display: "flex", alignItems: "center" }}
                              size={{
                                xs: 8,
                                md: 4,
                              }}
                            >
                              <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                                {t("SECTOR_&_ROLE")}
                              </h3>
                            </Grid>
                            <Grid
                              item
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                              size={{
                                xs: 4,
                                md: 8,
                              }}
                            >
                              <span style={{ marginLeft: "15px" }}>
                                {this.props.screen !== "checkout" && (
                                  <>
                                    {this.props.userPerms.includes(
                                      "PARTYMGR_ADMIN",
                                    ) &&
                                      this.props.loggedInUserType !==
                                      "ECOMMERCE_CUSTOMER" &&
                                      this.props.providerType ===
                                      "SALES_CHNL_PROVIDER" && (
                                        <Button
                                          className="buttonSecondary"
                                          onClick={() =>
                                            this.setState({
                                              showSectorRoleForm: false,
                                            })
                                          }
                                        >
                                          <CloseIcon />
                                          {/* {t("EDIT")} */}
                                        </Button>
                                      )}
                                  </>
                                )}
                              </span>
                            </Grid>
                            <Grid
                              style={{
                                marginTop: ".5rem",
                                marginBottom: ".5rem",
                              }}
                              size={{
                                xs: 12,
                              }}
                            >
                              <Divider variant="middle" />
                            </Grid>
                            <Grid
                              item
                              style={{}}
                              size={{
                                xs: 12,
                                md: 6,
                              }}
                            >
                              {/* <Input
                                                                name={"sector"}
                                                                value={this.state.sector}
                                                                variant={"outlined"}
                                                                onChange={(event) => this.changeSectorRole(event)}
                                                                placeholder={t("SECTOR") + " *"}
                                                                size={"small"}
                                                            /> */}
                              <FormControl
                                className="custom-select-input"
                                size={"small"}
                                variant={"outlined"}
                              >
                                <InputLabel htmlFor="outlined-age-native-simple">
                                  {t("SECTOR") + " *"}
                                </InputLabel>
                                <Select
                                  native
                                  label="SECTOR"
                                  value={this.state.sector}
                                  onChange={(event) =>
                                    this.changeSectorRole(event)
                                  }
                                  inputProps={{
                                    name: "sector",
                                    id: "outlined-age-native-simple",
                                  }}
                                  selectClass={classes.inputClass}
                                // style={{ width: "180px" }}
                                >
                                  <option value="" disabled>
                                    {t("SECTOR") + " *"}
                                  </option>
                                  {this.props.sectorsList.map(
                                    (sector, index) => (
                                      <option key={index} value={sector.id}>
                                        {sector.name}
                                      </option>
                                    ),
                                  )}
                                </Select>
                              </FormControl>
                              <div
                                style={{
                                  textAlign: "right",
                                  marginTop: "1rem",
                                }}
                              >
                                <Button
                                  onClick={() =>
                                    this.updateSectorRole("sector")
                                  }
                                >
                                  {t("UPDATE_SECTOR")}
                                </Button>
                              </div>
                            </Grid>
                            <Grid
                              item
                              style={{}}
                              size={{
                                xs: 12,
                                md: 6,
                              }}
                            >
                              <Input
                                name={"role"}
                                value={this.state.role}
                                variant={"outlined"}
                                onChange={(event) =>
                                  this.changeSectorRole(event)
                                }
                                placeholder={t("ROLE") + " *"}
                                size={"small"}
                              />
                              <div
                                style={{
                                  textAlign: "right",
                                  marginTop: "1rem",
                                }}
                              >
                                <Button
                                  onClick={() => this.updateSectorRole("role")}
                                >
                                  {t("UPDATE_ROLE")}
                                </Button>
                              </div>
                            </Grid>
                          </Grid>
                        </Box>
                      ) : (
                        <Box
                          className="roundCorners"
                          style={{
                            border: "1px solid lightgrey",
                            padding: "1.5rem",
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              style={{ display: "flex", alignItems: "center" }}
                              size={{
                                xs: 8,
                                md: 4,
                              }}
                            >
                              <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                                {t("SECTOR_&_ROLE")}
                              </h3>
                            </Grid>
                            <Grid
                              item
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                              size={{
                                xs: 4,
                                md: 8,
                              }}
                            >
                              <span style={{ marginLeft: "15px" }}>
                                {this.props.screen !== "checkout" && (
                                  <>
                                    {this.props.userPerms.includes(
                                      "PARTYMGR_ADMIN",
                                    ) &&
                                      this.props.loggedInUserType !==
                                      "ECOMMERCE_CUSTOMER" &&
                                      this.props.providerType ===
                                      "SALES_CHNL_PROVIDER" && (
                                        <Button
                                          className="buttonSecondary"
                                          onClick={() => this.editSectorRole()}
                                        >
                                          <span style={{ marginRight: "8px" }}>
                                            <svg
                                              width="14"
                                              height="13"
                                              viewBox="0 0 13 12"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </span>
                                          {t("EDIT")}
                                        </Button>
                                      )}
                                  </>
                                )}
                              </span>
                            </Grid>
                            <Grid
                              style={{
                                marginTop: ".5rem",
                                marginBottom: ".5rem",
                              }}
                              size={{
                                xs: 12,
                              }}
                            >
                              <Divider variant="middle" />
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 3,
                              }}
                            >
                              <b>{t("SECTOR")}</b>
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 9,
                              }}
                            >
                              {this.props.sectorsList &&
                                this.props.sectorsList.length > 0 ? (
                                <>
                                  {this.state.sector
                                    ? this.props.sectorsList.map(
                                      (entry, e) =>
                                        entry.id === this.state.sector &&
                                        entry.name,
                                    )
                                    : t("NOT_AVAILABLE")}
                                </>
                              ) : this.state.sector ? (
                                this.state.sector
                              ) : (
                                t("NOT_AVAILABLE")
                              )}
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 3,
                              }}
                            >
                              <b>{t("ROLE")}</b>
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 9,
                              }}
                            >
                              {this.state.role
                                ? this.state.role
                                : t("NOT_AVAILABLE")}
                            </Grid>
                          </Grid>
                        </Box>
                      )}
                    </div>
                  </div>
                )}
                {this.state.tabValue === 0 && (
                  <div>
                    <div>
                      <Box
                        className="roundCorners"
                        style={{
                          border: "1px solid lightgrey",
                          padding: "1.5rem",
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid
                            item
                            style={{ display: "flex", alignItems: "center" }}
                            size={{
                              xs: 8,
                              md: 4,
                            }}
                          >
                            <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                              {t("INFO")}
                            </h3>
                          </Grid>
                          <Grid
                            item
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                            size={{
                              xs: 4,
                              md: 8,
                            }}
                          >
                            <span style={{ marginLeft: "15px" }}>
                              {this.props.screen !== "checkout" && (
                                <>
                                  {this.props.userPerms.includes(
                                    "PARTYMGR_ADMIN",
                                  ) &&
                                    this.props.loggedInUserType !==
                                    "ECOMMERCE_CUSTOMER" &&
                                    this.props.providerType ===
                                    "SALES_CHNL_PROVIDER" && (
                                      <Button
                                        className="buttonSecondary"
                                        onClick={() =>
                                          this.toggleGeneralInfoForm()
                                        }
                                      >
                                        <span style={{ marginRight: "8px" }}>
                                          <svg
                                            width="14"
                                            height="13"
                                            viewBox="0 0 13 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              clipRule="evenodd"
                                              d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </span>
                                        {t("EDIT")}
                                      </Button>
                                    )}
                                  {/* {this.props.userPerms.includes('PARTYMGR_ADMIN') &&
                                                                        <Button onClick={(e) => this.props.addChildItem(e, this.state.profileData.partyId)} style={{ marginLeft: '15px' }}>{t('ADD')}</Button>
                                                                    } */}
                                </>
                              )}
                            </span>
                          </Grid>
                          <Grid
                            style={{
                              marginTop: ".5rem",
                              marginBottom: ".5rem",
                            }}
                            size={{
                              xs: 12,
                            }}
                          >
                            <Divider variant="middle" />
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 3,
                            }}
                          >
                            <b>{t("ACCOUNT_NAME")}</b>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            {this.state.profileData.accountName}
                          </Grid>
                          {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                            window.location.pathname !== "/manageLeads" && (
                              <>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 3,
                                  }}
                                >
                                  <b>{t("ACCOUNT_NUMBER")}</b>
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 9,
                                  }}
                                >
                                  {this.state.profileData.ban}
                                </Grid>
                              </>
                            )}
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 3,
                            }}
                          >
                            <b>{t("SHIPPING_ADDRESS")}</b>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            {this.state.profileData.shipping &&
                              this.state.profileData.shipping.length > 0 &&
                              (this.state.stateNameLoading ? (
                                "Loading..."
                              ) : (
                                <>
                                  {this.state.profileData.shipping[0].attention}
                                  :&nbsp;
                                  {this.state.profileData.shipping[0].street1}
                                  ,&nbsp;
                                  {this.state.profileData.shipping[0].street2 &&
                                    this.state.profileData.shipping[0]
                                      .street2 !== "" &&
                                    this.state.profileData.shipping[0].street2 +
                                    ", "}
                                  {this.state.profileData.shipping[0].city}
                                  {this.state.stateName ? "," : ""}&nbsp;
                                  {this.state.stateName}&nbsp;
                                  {this.state.profileData.shipping[0].zipCode
                                    ? this.state.profileData.shipping[0]
                                      .zipCode + ","
                                    : this.state.profileData.shipping[0].zip
                                      ? this.state.profileData.shipping[0].zip +
                                      ","
                                      : ""}
                                  &nbsp;
                                  {this.state.profileData.shipping[0].country
                                    ? this.setCountryName(
                                      this.state.profileData.shipping[0]
                                        .country,
                                    )
                                    : ""}
                                </>
                              ))}
                          </Grid>
                          {(this.state.profileData.firstName ||
                            this.state.profileData.lastName) && (
                              <>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 3,
                                  }}
                                >
                                  <b>{t("CONTACT")}</b>
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 9,
                                  }}
                                >
                                  {this.state.profileData.firstName
                                    ? this.state.profileData.firstName
                                    : ""}{" "}
                                  {this.state.profileData.lastName
                                    ? this.state.profileData.lastName
                                    : ""}
                                </Grid>
                              </>
                            )}
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 3,
                            }}
                          >
                            <b>{t("OFFICE_PHONE")}</b>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            {this.state.profileData.officePhone}
                          </Grid>
                          {this.state.profileData.mobilePhone && (
                            <>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 3,
                                }}
                              >
                                <b>{t("MOBILE_PHONE")}</b>
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 9,
                                }}
                              >
                                {this.state.profileData.mobilePhone}
                              </Grid>
                            </>
                          )}
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 3,
                            }}
                          >
                            <b>{t("EMAIL")}</b>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            {this.state.profileData.email}
                          </Grid>
                          {this.state.modules &&
                            this.state.modules.module_payment === "enabled" && (
                              <>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 3,
                                  }}
                                >
                                  <b>{t("BILLING_CLOSE_DAY")}</b>
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 9,
                                  }}
                                >
                                  {this.state.profileData.billingCloseDay}
                                </Grid>
                              </>
                            )}
                          {this.props.showMyCustomers &&
                            this.state.profileData.createdByUser && (
                              <>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 3,
                                  }}
                                >
                                  <b>{t("CREATED_BY")}</b>
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 9,
                                  }}
                                >
                                  {this.state.profileData.createdByUser}
                                </Grid>
                              </>
                            )}
                          {this.state.profileData.createdDate && (
                            <>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 3,
                                }}
                              >
                                <b>{t("CREATED_DATE")}</b>
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 9,
                                }}
                              >
                                {/* {this.state.profileData.createdDate} */}
                                {formatDate(this.state.profileData.createdDate)}
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </Box>
                    </div>
                    {this.props.isChild || this.props.screen === "checkout"
                      ? null
                      : this.state.modules &&
                      this.state.modules.module_customer_billing ===
                      "enabled" && (
                        <div style={{ marginTop: "1rem" }}>
                          <AddressDetails
                            tabValue={2}
                            customerDetails={this.props.customerDetails}
                            addressDetails={this.props.addressDetails}
                            partyId={this.state.profileData.partyId}
                            reloadCustomerData={this.props.reloadCustomerData}
                            modules={this.state.modules}
                            userPerms={this.props.userPerms}
                          />
                        </div>
                      )}
                  </div>
                )}
              </>
            )}
            {this.props.isChild || this.props.screen === "checkout" ? null : (
              <>
                {this.state.tabValue === 1 && (
                  <div>
                    <PaymentDetails
                      tabValue={3}
                      creditCardList={this.props.creditCardList}
                      eftAccountList={this.props.eftAccountList}
                      customerDetails={this.props.customerDetails}
                      paymentMethodList={this.props.paymentMethodList}
                      billingAddressList={this.props.billingAddressList}
                      partyId={this.state.profileData.partyId}
                    />
                  </div>
                )}
                {this.state.tabValue === 2 && (
                  <div>
                    <Box
                      className="roundCorners"
                      style={{
                        border: "1px solid lightgrey",
                        padding: "1.5rem",
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid
                          item
                          style={{ display: "flex", alignItems: "center" }}
                          size={{
                            xs: 8,
                            md: 4,
                          }}
                        >
                          <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                            {t("CUSTOMER_NOTES")}
                          </h3>
                        </Grid>
                        <Grid
                          item
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                          size={{
                            xs: 4,
                            md: 8,
                          }}
                        >
                          <span style={{ marginLeft: "15px" }}>
                            {this.props.providerType ===
                              "SALES_CHNL_PROVIDER" &&
                              !this.state.editNote &&
                              getDraftContentStats(this.state.customerNote, 'chars') > 0 &&
                              // this.state.notesState
                              //   .getCurrentContent()
                              //   .hasText() &&
                              (
                                <Button
                                  className={"buttonSecondary"}
                                  onClick={() =>
                                    this.setState({ editNote: true })
                                  }
                                >
                                  <span style={{ marginRight: "8px" }}>
                                    <svg
                                      width="14"
                                      height="13"
                                      viewBox="0 0 13 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {t("EDIT")}
                                </Button>
                              )}
                          </span>
                        </Grid>
                        <Grid
                          style={{ marginTop: ".5rem", marginBottom: ".5rem" }}
                          size={{
                            xs: 12,
                          }}
                        >
                          {(
                            // this.state.notesState
                            // .getCurrentContent()
                            // .hasText() 
                            // ||
                            getDraftContentStats(this.state.customerNote, 'chars') > 0 ||
                            this.state.editNote) && (
                              <Divider variant="middle" />
                            )}
                        </Grid>
                      </Grid>
                      {/* <div>
                                                <div style={{ marginBottom: this.props.screen === "paymentMethod" ? "2rem" : 0 }}>
                                                    <h3 style={{ marginTop: 0, marginBottom: 0, float: "left" }}>{t("CUSTOMER_NOTES")}</h3>
                                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                        {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                                                            !this.state.editNote &&
                                                            this.state.notesState.getCurrentContent().hasText() && (
                                                                <Button className={"buttonSecondary"} onClick={() => this.setState({ editNote: true })}>
                                                                    <span style={{ marginRight: "8px" }}>
                                                                                    <svg width="14" height="13" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path
                                                                                            fill-rule="evenodd"
                                                                                            clip-rule="evenodd"
                                                                                            d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                                                                            fill="currentColor"
                                                                                        />
                                                                                    </svg>
                                                                                </span>
                                                                    {t("EDIT")}
                                                                </Button>
                                                            )}
                                                    </div>
                                                </div>
                                            </div> */}
                      {/* <Box className="roundCorners" style={{ border: "1px solid lightgrey", marginTop: "1rem" }}> */}
                      {getDraftContentStats(this.state.customerNote, 'chars') > 0 ||
                        // this.state.notesState.getCurrentContent().hasText() ||
                        this.state.editNote ? (
                        <Grid container spacing={2}>
                          <Grid
                            item
                            size={{
                              xs: 12,
                            }}
                          >
                            <TiptapEditor
                              value={this.state.customerNote}
                              onChange={this.onChangeNotes}
                              placeholder={t("NOTES")}
                              // readOnly={this.props.providerType === "SALES_CHNL_PROVIDER" ? false : true}
                              readOnly={this.state.editNote ? false : true}
                              maxCharLimit={this.state.MAX_CHAR_LIMIT}
                            />
                          </Grid>
                          <Grid
                            item
                            align="right"
                            size={{
                              xs: 12,
                            }}
                          >
                            {this.props.providerType ===
                              "SALES_CHNL_PROVIDER" &&
                              this.state.editNote && (
                                <>
                                  <Button
                                    className="buttonSecondary"
                                    onClick={() => this.cancelNotesEditing()}
                                    style={{ marginRight: "15px" }}
                                  >
                                    {t("CANCEL")}
                                  </Button>
                                  <Button
                                    onClick={() => this.onSaveNotesData()}
                                  >
                                    {t("SAVE")}
                                  </Button>
                                </>
                              )}
                          </Grid>
                        </Grid>
                      ) : (
                        //     )}

                        // {!this.state.notesState.getCurrentContent().hasText() && !this.state.editNote &&
                        <Grid container spacing={2} align="center">
                          <Grid
                            item
                            size={{
                              xs: 12,
                            }}
                          >
                            {t("NO_NOTES_ADDED")}
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                            }}
                          >
                            {this.props.providerType ===
                              "SALES_CHNL_PROVIDER" &&
                              this.props.userPerms.includes(
                                "PARTYMGR_ADMIN",
                              ) && (
                                <Button
                                  className={"buttonSecondary"}
                                  onClick={() =>
                                    this.setState({ editNote: true })
                                  }
                                >
                                  <span
                                    style={{
                                      marginRight: ".25rem",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 12 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {t("ADD_A NOTE")}
                                </Button>
                              )}
                          </Grid>
                        </Grid>
                      )}
                      {/* </Box> */}
                      {/* <Table className={classes.shippingTableClass + " " + classes.noBorder}>
														<TableHead>
															<TableRow>
																<TableCell>
																	<h3 style={{ marginTop: 0, marginBottom: 0 }}>{t("CUSTOMER_NOTES")}</h3>
																</TableCell>
															</TableRow>
														</TableHead>
														<TableBody>
															<TableRow>
																<TableCell>
																	<TextEditor
																		editorState={this.state.notesState}
																		onChange={this.onChangeNotes}
																		placeholder={t("NOTES")}
																		readOnly={this.props.providerType === "SALES_CHNL_PROVIDER" ? false : true}
																	/>
																</TableCell>
															</TableRow>
															{this.props.providerType === "SALES_CHNL_PROVIDER" && (
																<TableRow>
																	<TableCell align="right">
																		<Button onClick={() => this.onSaveNotesData()}>{t("SAVE")}</Button>
																	</TableCell>
																</TableRow>
															)}
														</TableBody>
													</Table> */}
                    </Box>
                  </div>
                )}
                {this.state.tabValue === 3 && (
                  <div>
                    {this.state.assessmentLoading ? (
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "16px",
                          marginTop: "2rem",
                        }}
                      >
                        {t("SEARCHING")}
                      </div>
                    ) : (
                      <Box
                        className="roundCorners"
                        style={{
                          border: "1px solid lightgrey",
                          padding: "1.5rem",
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid
                            item
                            style={{ display: "flex", alignItems: "center" }}
                            size={{
                              xs: 8,
                              md: 4,
                            }}
                          >
                            <h3 style={{ marginTop: 0, marginBottom: 0 }}>
                              {t("ASSESSMENTS")}
                            </h3>
                          </Grid>
                          <Grid
                            item
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                            size={{
                              xs: 4,
                              md: 8,
                            }}
                          >
                            <span style={{ marginLeft: "15px" }}>
                              {this.props.providerType ===
                                "SALES_CHNL_PROVIDER" &&
                                this.props.userPerms.includes(
                                  "PARTYMGR_ADMIN",
                                ) &&
                                this.state.attachments &&
                                this.state.attachments.length > 0 && (
                                  <Button
                                    className={"buttonSecondary"}
                                    onClick={() =>
                                      this.setState({ showUploadDailog: true })
                                    }
                                  >
                                    <span
                                      style={{
                                        marginRight: ".25rem",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {t("UPLOAD_NEW_FILE")}
                                  </Button>
                                )}
                            </span>
                          </Grid>
                          <Grid
                            style={{
                              marginTop: ".5rem",
                              marginBottom: ".5rem",
                            }}
                            size={{
                              xs: 12,
                            }}
                          ></Grid>
                        </Grid>
                        {(!this.state.attachments ||
                          this.state.attachments.length === 0) && (
                            <Grid container spacing={2} align="center">
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                }}
                              >
                                {t("NO_DATA_FOUND")}
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                }}
                              >
                                {this.props.providerType ===
                                  "SALES_CHNL_PROVIDER" &&
                                  this.props.userPerms.includes(
                                    "PARTYMGR_ADMIN",
                                  ) && (
                                    <Button
                                      className={"buttonSecondary"}
                                      onClick={() =>
                                        this.setState({ showUploadDailog: true })
                                      }
                                    >
                                      <span
                                        style={{
                                          marginRight: ".25rem",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 12 12"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {t("UPLOAD_NEW_FILE")}
                                    </Button>
                                  )}
                              </Grid>
                            </Grid>
                          )}
                        {this.state.attachments &&
                          this.state.attachments.length > 0 && (
                            <div>
                              <Grid container item spacing={3}>
                                <TableContainer>
                                  <Table
                                    className="newGlobalTable roundCorners borderOutline"
                                    style={{ padding: 0 }}
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>{t("NAME")}</TableCell>
                                        <TableCell
                                          className="global-custom-sorting-header"
                                          onClick={() =>
                                            this.handleAttachmentSort(
                                              "createdStamp",
                                            )
                                          }
                                        >
                                          <b>{t("CREATED_DATE")}</b>
                                          {this.state.attachmentSortBy ===
                                            "createdStamp" ? (
                                            <span className="material-icons">
                                              {this.state
                                                .attachmentSortOrder === "DESC"
                                                ? "expand_less"
                                                : "expand_more"}
                                            </span>
                                          ) : (
                                            <span className="material-icons sorting-indicator-icon">
                                              unfold_more
                                            </span>
                                          )}
                                        </TableCell>
                                        <TableCell>{t("ACTIONS")}</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {this.state.attachments.map(
                                        (item, index) => (
                                          <TableRow>
                                            <TableCell>{item.name}</TableCell>
                                            {/* <TableCell>{moment(item.createdDate).format('MMMM Do, YYYY, h:mm A')}</TableCell> */}
                                            <TableCell>
                                              {formatDate(item.createdDate)}
                                            </TableCell>
                                            <TableCell
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <Tooltip title={t("VIEW")}>
                                                <IconButton
                                                  className="buttonSecondary"
                                                  onClick={() =>
                                                    this.viewAttachmentFile(
                                                      item,
                                                    )
                                                  }
                                                >
                                                  <ViewIconNew />
                                                </IconButton>
                                              </Tooltip>
                                              <Tooltip title={t("DOWNLOAD")}>
                                                <IconButton
                                                  className="buttonSecondary"
                                                  style={{
                                                    marginLeft: ".5rem",
                                                  }}
                                                  onClick={() =>
                                                    this.openAttachmentFile(
                                                      item,
                                                    )
                                                  }
                                                >
                                                  <DownloadIconNew />
                                                </IconButton>
                                              </Tooltip>
                                              {this.props.providerType ===
                                                "SALES_CHNL_PROVIDER" && (
                                                  <Tooltip title={t("DELETE")}>
                                                    <IconButton
                                                      className="buttonSecondary"
                                                      style={{
                                                        marginLeft: ".5rem",
                                                      }}
                                                      onClick={() =>
                                                        this.deleteAttachment(
                                                          item,
                                                        )
                                                      }
                                                    >
                                                      <DeleteIconNew />
                                                    </IconButton>
                                                  </Tooltip>
                                                )}
                                            </TableCell>
                                          </TableRow>
                                        ),
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                {/* {this.state.attachments.map((item, index) => (
                                                                    <Grid item xs={6} md={2} key={index} style={{ wordBreak: 'break-word', textAlign: 'center', position: 'relative' }}>
                                                                        <Tooltip title={t('DOWNLOAD')}>
                                                                            {item.mimeType === "application/pdf" ? (
                                                                                <div>
                                                                                    <img
                                                                                        src={item.mimeType === "application/pdf" ? pdfIcon : placeholderImage}
                                                                                        style={{ width: "100%", cursor: "pointer" }}
                                                                                        onClick={(e) => this.openAttachmentFile(item)}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div style={{}}>
                                                                                    <img
                                                                                        src={item.mimeType === "application/pdf" ? pdfIcon : placeholderImage}
                                                                                        style={{ width: "93%", cursor: "pointer" }}
                                                                                        onClick={(e) => this.openAttachmentFile(item)}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </Tooltip>
                                                                        <br />
                                                                        {item.name}
                                                                        {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                                                                            <Tooltip title={t("DELETE")}>
                                                                                <IconButton
                                                                                    onClick={() => this.deleteAttachment(item)}
                                                                                    style={{ position: "absolute", top: "-7px", right: item.mimeType === "application/pdf" ? "10px" : "4px" }}
                                                                                >
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        )}
                                                                    </Grid>
                                                                ))} */}
                              </Grid>
                            </div>
                          )}
                      </Box>
                    )}
                  </div>
                )}
                <Dialog
                  open={this.state.showUploadDailog}
                  PaperComponent={this.draggableDialogPaper}
                  aria-labelledby="form-dialog-title"
                  fullWidth={true}
                  maxWidth={"sm"}
                  PaperProps={
                    {
                      // className: jssClasses.resizablePaper
                    }
                  }
                >
                  <DialogTitle
                    id="draggableDialogPaper"
                    style={{ cursor: "move" }}
                    className={classes.paymentMethods}
                  >
                    <div style={{ display: "flex" }}>
                      <span style={{ display: "inline-flex", width: "95%" }}>
                        {t("UPLOAD")}
                      </span>
                      <Tooltip title={t("CLOSE")}>
                        <IconButton
                          onTouchStart={() =>
                            this.setState({
                              showUploadDailog: false,
                              assessmentData: {
                                name: "",
                                data: "",
                                fileName: "",
                                format: "",
                              },
                              selectedReviewers: [],
                              showAddReviewer: false,
                            })
                          }
                          onClick={() =>
                            this.setState({
                              showUploadDailog: false,
                              assessmentData: {
                                name: "",
                                data: "",
                                fileName: "",
                                format: "",
                              },
                              selectedReviewers: [],
                              showAddReviewer: false,
                            })
                          }
                          aria-label="close"
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </DialogTitle>
                  <DialogContent dividers>
                    <Grid container spacing={1}>
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <Input
                          name={"name"}
                          value={this.state.assessmentData.name}
                          variant={"outlined"}
                          onChange={(event) => this.onChangeAssesment(event)}
                          placeholder={t("NAME") + " *"}
                          size={"small"}
                        />
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <Input
                          inputProps={{
                            id: "documentFile",
                            accept:
                              "application/pdf, image/png, image/jpeg, image/jpg",
                          }}
                          type="file"
                          name={"documentFile"}
                          className="custom-file-input"
                          onChange={(event) => this.onDocumentUpload(event)}
                          source={this.state.assessmentData.data}
                        />
                        <label
                          htmlFor="documentFile"
                          className={"input-file-label"}
                        >
                          <Icon>attach_file</Icon>
                          <label>
                            {" "}
                            {this.state.assessmentData.fileName ? (
                              this.state.assessmentData.fileName
                            ) : (
                              <span className="input-file-placeholder">
                                {t("UPLOAD_DOCUMENT_FILE_PDF_IMAGES_ONLY")}
                              </span>
                            )}
                          </label>
                        </label>
                        <span
                          style={{
                            color: "rgba(0, 0, 0, 0.54)",
                            fontSize: "0.75rem",
                          }}
                        >
                          The maximum allowed file size is 5MB
                        </span>
                      </Grid>
                    </Grid>
                    {/* add a reviewer */}
                    {this.state.reviewers &&
                      Object.keys(this.state.reviewers).length > 0 && (
                        <Grid
                          container
                          spacing={1}
                          className="roundCorners borderOutline"
                          style={{ marginTop: "1rem" }}
                        >
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <h3
                              style={{
                                marginTop: 0,
                                marginBottom: 0,
                                float: "left",
                              }}
                            >
                              {t("REVIEWERS")}
                            </h3>
                          </Grid>
                          <Grid
                            item
                            style={{ textAlign: "right" }}
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <Button
                              className="buttonSecondary"
                              onClick={this.toggleAddReviewer}
                            >
                              <span
                                style={{
                                  marginRight: this.state.showAddReviewer
                                    ? "0px"
                                    : "8px",
                                }}
                              >
                                {this.state.showAddReviewer ? (
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.5 2.5L9.5 9.5M2.5 9.5L9.5 2.5"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                )}
                              </span>
                              {this.state.showAddReviewer
                                ? ""
                                : t("ADD_A_REVIEWER")}
                            </Button>
                          </Grid>
                          {this.state.showAddReviewer && (
                            <>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                }}
                              >
                                <Divider />
                                <p>{t("ADD_A_REVIEWER")}</p>
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                }}
                              >
                                <DynamicDropdowns
                                  data={this.state.reviewers}
                                  structure={this.state.dropdownStructure}
                                  onReviewerSelected={(reviewerData) => {
                                    this.handleReviewerSelected(reviewerData);
                                    this.setState({ showAddReviewer: false }); // Hide after adding
                                  }}
                                />
                              </Grid>
                            </>
                          )}
                          {this.state.selectedReviewers &&
                            this.state.selectedReviewers.length > 0 && (
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                }}
                              >
                                <Divider />
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: ".5rem",
                                    marginTop: ".5rem",
                                  }}
                                >
                                  {this.state.selectedReviewers.map(
                                    (reviewer) => (
                                      <Chip
                                        key={reviewer.employeeId}
                                        label={`${reviewer.employee} (${reviewer.role}${reviewer.provider ? ` - ${reviewer.provider}` : ""})`}
                                        onDelete={() =>
                                          this.handleDeleteReviewer(
                                            reviewer.employeeId,
                                          )
                                        }
                                        // style={{ margin: '4px' }}
                                        className="blueChip"
                                      />
                                    ),
                                  )}
                                </div>
                              </Grid>
                            )}
                        </Grid>
                      )}
                  </DialogContent>
                  <DialogActions style={{ justifyContent: "normal" }}>
                    <Box style={{ width: '100%' }}>
                      <Grid container spacing={2}>
                        <Grid
                          item
                          size={{
                            xs: 9,
                          }}
                        >
                          {this.state.uploadAssesmentError.show && (
                            <span
                              style={{ fontWeight: "bold", color: "#f44336" }}
                            >
                              {this.state.uploadAssesmentError.msg}
                            </span>
                          )}
                        </Grid>
                        <Grid
                          item
                          style={{ textAlign: "right" }}
                          size={{
                            xs: 3,
                          }}
                        >
                          <Button
                            onClick={(event) => this.uploadAssesment()}
                            color="primary"
                          >
                            {t("UPLOAD")}
                          </Button>
                        </Grid>
                      </Grid>
                      {/* <div style={{ float: 'left' }}>
                                            {this.state.uploadAssesmentError.show &&
                                                <span style={{ fontWeight: 'bold', color: '#f44336' }}>
                                                    {this.state.uploadAssesmentError.msg}
                                                </span>
                                            }
                                        </div>
                                        <div style={{ float: 'right' }}>
                                            <Button onClick={event => this.uploadAssesment()} color="primary">{t('UPLOAD')}</Button>
                                        </div>
                                        <div style={{ clear: 'both' }}></div> */}
                    </Box>
                  </DialogActions>
                </Dialog>
              </>
            )}

            {this.state.confirmDeleteAttachment && (
              <Dialog
                open={this.state.confirmDeleteAttachment}
                PaperComponent={this.draggableDialogPaper}
                aria-labelledby="form-dialog-title"
                fullWidth={true}
                maxWidth={"sm"}
                PaperProps={
                  {
                    // className: jssClasses.resizablePaper
                  }
                }
              >
                <DialogTitle
                  id="draggableDialogPaper"
                  style={{ cursor: "move" }}
                  className={classes.paymentMethods}
                >
                  <div style={{ display: "flex" }}>
                    <span style={{ display: "inline-flex", width: "95%" }}>
                      {t("DELETE")}
                    </span>
                    <Tooltip title={t("CLOSE")}>
                      <IconButton
                        onTouchStart={() =>
                          this.setState({
                            attachmentToDelete: {},
                            confirmDeleteAttachment: false,
                          })
                        }
                        onClick={() =>
                          this.setState({
                            attachmentToDelete: {},
                            confirmDeleteAttachment: false,
                          })
                        }
                        aria-label="close"
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                </DialogTitle>
                <DialogContent dividers>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      {t("DELETE_ASSESSMENT_CONFIRMATION")}
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions style={{ justifyContent: "flex-end" }}>
                  <div>
                    <Button
                      onClick={() =>
                        this.setState({
                          attachmentToDelete: {},
                          confirmDeleteAttachment: false,
                        })
                      }
                      color="primary"
                    >
                      {t("NO")}
                    </Button>
                    <Button
                      onClick={(event) => this.confirmDeleteAssesment()}
                      style={{ marginLeft: "15px" }}
                      color="primary"
                    >
                      {t("YES")}
                    </Button>
                  </div>
                </DialogActions>
              </Dialog>
            )}
            {this.state.tabValue === 4 && (
              <>
                {this.props.isChild ||
                  this.props.screen === "checkout" ? null : (
                  <div>
                    <Box
                      className="roundCorners"
                      style={{
                        border: "1px solid lightgrey",
                        padding: "1.5rem",
                      }}
                    >
                      <div style={{ marginBottom: "2rem" }}>
                        <h3 style={{ marginTop: 0, float: "left" }}>
                          {t("USERS")}
                        </h3>
                      </div>
                      {this.props.isChild ||
                        this.props.screen === "checkout" ? null : (
                        <>
                          {this.state.profileData.customersEmployeeList &&
                            this.state.profileData.customersEmployeeList.map(
                              (employee, index) => (
                                <React.Fragment key={index}>
                                  <Box
                                    className="roundCorners"
                                    style={{
                                      border: "1px solid lightgrey",
                                      marginTop: "1rem",
                                      padding: "1.5rem",
                                    }}
                                  >
                                    <Grid container spacing={2}>
                                      <Grid
                                        item
                                        size={{
                                          xs: 12,
                                          md: 3,
                                        }}
                                      >
                                        <div style={{ color: "#717784" }}>
                                          {t("NAME")}
                                        </div>
                                        <div>
                                          {employee.firstName}{" "}
                                          {employee.lastName}
                                        </div>
                                      </Grid>
                                      <Grid
                                        item
                                        size={{
                                          xs: 12,
                                          md: 9,
                                        }}
                                      >
                                        <div style={{ color: "#717784" }}>
                                          {t("EMAIL")}
                                        </div>
                                        <div>{employee.email}</div>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                </React.Fragment>
                              ),
                            )}
                        </>
                      )}
                      {(this.state.profileData.customersEmployeeList ==
                        undefined ||
                        this.state.profileData.customersEmployeeList.length ==
                        0) && (
                          <Grid container spacing={2} align="center">
                            <Grid
                              item
                              size={{
                                xs: 12,
                              }}
                            >
                              {t("NO_USERS_AVAILABLE")}
                            </Grid>
                          </Grid>
                        )}
                    </Box>
                  </div>
                )}
              </>
            )}
          </>
        )}
        {this.state.showFileData && (
          <Base64ViewerDialog
            base64={this.state.selectedFileToView.attachment}
            mimeType={this.state.selectedFileToView.mimeType}
            title={this.state.selectedFileToView.name}
            open={this.state.showFileData}
            onClose={() => {
              this.setState({ showFileData: false, selectedFileToView: {} });
            }}
          />
        )}
        {this.state.showUsernameDialog &&
          <SearchUsersDialog
            open={this.state.showUsernameDialog}
            onClose={this.onCloseUsernameDialog}
            selectUser={this.selectUser}
            screen={'edit'}
          />
        }
        <Loader loading={this.state.loading} />
        <Loader loading={this.state.partialLoading} />
      </div>
    );
  }
}

// const styles = {

//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '40vw',
//     },
// };
const mapStateToProps = (state) => {
  return {
    countriesList: state.global.countriesList,
    providerType: state.auth.providerType,
    tenantData: state.auth.tenantData,
    defaultCountry: state.auth.defaultCountry,
    showMyCustomers: state.auth.showMyCustomers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(CustomerDetails));
